// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import {
//   FaPlus,
//   FaEdit,
//   FaTrash,
//   FaEye,
//   FaEyeSlash,
//   FaShoppingBag,
//   FaDollarSign,
//   FaSearch,
//   FaThLarge,
//   FaList,
//   FaBoxes,
//   FaImage,
//   FaSpinner,
//   FaCalendarAlt,
//   FaRulerCombined,
//   FaWeight,
//   FaPalette,
//   FaVideo,
//   FaTimes,
//   FaUpload,
//   FaTimesCircle,
//   FaCheckCircle,
//   FaInfoCircle,
//   FaTag,
//   FaStore,
//   FaChevronLeft,
//   FaChevronRight,
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import './readyproducts.scss';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';
// import { serverUrlAuth } from '../../../../serverUrl';

// const IMAGE_LABELS = {
//   front: 'Front View',
//   back: 'Back View',
//   left: 'Left Side',
//   right: 'Right Side'
// };

// const ArtisanReadyProducts = () => {
//   const [viewMode, setViewMode] = useState('grid');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [productToDelete, setProductToDelete] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState({
//     add: false,
//     edit: false,
//     delete: false,
//     toggleStatus: false,
//   });
//   const [shopStats, setShopStats] = useState({
//     totalProducts: 0,
//     activeProducts: 0,
//     totalSales: 0,
//     totalRevenue: 0,
//     lowStock: 0,
//     outOfStock: 0,
//   });

//   const MATERIAL_CHOICES = [
//     { value: 'wood', label: 'Wood' },
//     { value: 'metal', label: 'Metal' },
//     { value: 'plastic', label: 'Plastic' },
//     { value: 'glass', label: 'Glass' },
//     { value: 'fabric', label: 'Fabric' },
//     { value: 'leather', label: 'Leather' },
//     { value: 'ceramic', label: 'Ceramic' },
//     { value: 'concrete', label: 'Concrete' },
//     { value: 'rattan', label: 'Rattan' },
//     { value: 'bamboo', label: 'Bamboo' },
//     { value: 'stone', label: 'Stone' },
//     { value: 'mixed', label: 'Mixed Materials' },
//     { value: 'other', label: 'Other' },
//   ];

//   const CATEGORY_CHOICES = [
//     { value: 'furniture', label: 'Furniture' },
//     { value: 'decor', label: 'Home Decor' },
//     { value: 'art', label: 'Art & Crafts' },
//     { value: 'clothing', label: 'Clothing' },
//     { value: 'other', label: 'Other' },
//   ];

//   const DIMENSION_UNIT_CHOICES = [
//     { value: 'cm', label: 'Centimeters (cm)' },
//     { value: 'm', label: 'Meters (m)' },
//     { value: 'in', label: 'Inches (in)' },
//   ];

//   const WEIGHT_UNIT_CHOICES = [
//     { value: 'kg', label: 'Kilograms (kg)' },
//     { value: 'g', label: 'Grams (g)' },
//   ];

//   const [newProduct, setNewProduct] = useState({
//     name: '',
//     material: 'wood',
//     category: 'furniture',
//     description: '',
//     how_it_works: '',
//     key_features: '',
//     length: '',
//     width: '',
//     height: '',
//     dimension_unit: 'cm',
//     weight: '',
//     weight_unit: 'kg',
//     location: '',
//     is_available: true,
//     colorOptions: [],
//   });

//   const [editProduct, setEditProduct] = useState({
//     name: '',
//     material: '',
//     category: '',
//     description: '',
//     how_it_works: '',
//     key_features: '',
//     length: '',
//     width: '',
//     height: '',
//     dimension_unit: 'cm',
//     weight: '',
//     weight_unit: 'kg',
//     location: '',
//     is_available: true,
//   });

//   // Edit variant state
//   const [editVariants, setEditVariants] = useState([]);
//   const [showEditVariantModal, setShowEditVariantModal] = useState(false);
//   const [editingVariantId, setEditingVariantId] = useState(null);
//   const [editingVariantIndex, setEditingVariantIndex] = useState(null);

//   const [editVariant, setEditVariant] = useState({
//     color_name: '',
//     color_code: '#000000',
//     original_price: '',
//     selling_price: '',
//     sale_start_date: '',
//     sale_end_date: '',
//     stock: '1',
//     is_available: true,
//   });

//   const [newColorOption, setNewColorOption] = useState({
//     color: '',
//     color_code: '#000000',
//     original_price: '',
//     selling_price: '',
//     sale_start_date: '',
//     sale_end_date: '',
//     stock: '1',
//     is_available: true,
//     frontImage: null,
//     backImage: null,
//     leftImage: null,
//     rightImage: null,
//     videoFile: null,
//     frontPreview: null,
//     backPreview: null,
//     leftPreview: null,
//     rightPreview: null,
//     videoPreview: null,
//   });

//   const [showAddColorModal, setShowAddColorModal] = useState(false);
//   const [editingColorIndex, setEditingColorIndex] = useState(null);

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     if (products.length > 0) {
//       calculateShopStats();
//     }
//   }, [products]);

//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('projects/ready-made-products/');
//       setProducts(response.data);
//     } catch (error) {
//       console.error('Error fetching products:', error);
//       toast.error('Failed to load products');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateShopStats = () => {
//     let totalRevenue = 0;
//     products.forEach(product => {
//       if (product.variants) {
//         product.variants.forEach(variant => {
//           // ✅ Use correct price based on sale status
//           const price = variant.is_on_sale ? parseFloat(variant.selling_price || 0) : parseFloat(variant.original_price || 0);
//           totalRevenue += price * (variant.sold_count || 0);
//         });
//       }
//     });

//     const stats = {
//       totalProducts: products.length,
//       activeProducts: products.filter((p) => p.is_available).length,
//       totalSales: products.reduce((sum, p) => {
//         let variantSum = 0;
//         if (p.variants) {
//           p.variants.forEach(v => variantSum += (v.sold_count || 0));
//         }
//         return sum + variantSum;
//       }, 0),
//       totalRevenue: totalRevenue,
//       lowStock: products.filter((p) => {
//         let totalStock = 0;
//         if (p.variants) {
//           p.variants.forEach(v => totalStock += (v.stock || 0));
//         }
//         return totalStock > 0 && totalStock <= 5;
//       }).length,
//       outOfStock: products.filter((p) => {
//         let totalStock = 0;
//         if (p.variants) {
//           p.variants.forEach(v => totalStock += (v.stock || 0));
//         }
//         return totalStock === 0;
//       }).length,
//     };
//     setShopStats(stats);
//   };

//   const filteredProducts = products.filter((product) => {
//     const matchesSearch =
//       product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       product.code?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesStatus =
//       filterStatus === 'all'
//         ? true
//         : filterStatus === 'active'
//           ? product.is_available
//           : filterStatus === 'inactive'
//             ? !product.is_available
//             : true;

//     return matchesSearch && matchesStatus;
//   });

//   const formatCurrency = (amount) => {
//     if (!amount || amount === '0.00' || amount === 0) return 'KSh 0';
//     return `KSh ${parseFloat(amount).toLocaleString()}`;
//   };

//   // ✅ Helper to get the correct display price for a variant
//   const getVariantDisplayPrice = (variant) => {
//     if (!variant) return 0;
//     if (variant.is_on_sale) {
//       return parseFloat(variant.selling_price || 0);
//     }
//     return parseFloat(variant.original_price || 0);
//   };

//   // ✅ Get price range correctly - shows original price when not on sale
//   const getPriceRange = (product) => {
//     if (!product.variants || product.variants.length === 0) return 'KSh 0';
    
//     const prices = product.variants.map(v => {
//       return v.is_on_sale ? parseFloat(v.selling_price || 0) : parseFloat(v.original_price || 0);
//     });
    
//     const min = Math.min(...prices);
//     const max = Math.max(...prices);
//     if (min === max) return formatCurrency(min);
//     return `${formatCurrency(min)} - ${formatCurrency(max)}`;
//   };

//   // ✅ Check if product is on sale
//   const isProductOnSale = (product) => {
//     if (!product.variants || product.variants.length === 0) return false;
//     return product.variants.some(v => v.is_on_sale === true);
//   };

//   // ✅ Get max discount percentage
//   const getProductDiscount = (product) => {
//     if (!product.variants || product.variants.length === 0) return 0;
//     const discounts = product.variants.map(v => {
//       if (!v.is_on_sale) return 0;
//       const original = parseFloat(v.original_price || 0);
//       const selling = parseFloat(v.selling_price || 0);
//       if (original === 0 || selling === 0) return 0;
//       return Math.round(((original - selling) / original) * 100);
//     });
//     return Math.max(...discounts);
//   };

//   // Handle color image upload for ADD modal
//   const handleColorImageUpload = (type, e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const preview = URL.createObjectURL(file);
//       setNewColorOption({
//         ...newColorOption,
//         [`${type}Image`]: file,
//         [`${type}Preview`]: preview,
//       });
//     }
//   };

//   const removeColorImage = (type) => {
//     if (newColorOption[`${type}Preview`]) {
//       URL.revokeObjectURL(newColorOption[`${type}Preview`]);
//     }
//     setNewColorOption({
//       ...newColorOption,
//       [`${type}Image`]: null,
//       [`${type}Preview`]: null,
//     });
//   };

//   const handleColorVideoUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const preview = URL.createObjectURL(file);
//       setNewColorOption({
//         ...newColorOption,
//         videoFile: file,
//         videoPreview: preview,
//       });
//     }
//   };

//   const removeColorVideo = () => {
//     if (newColorOption.videoPreview) {
//       URL.revokeObjectURL(newColorOption.videoPreview);
//     }
//     setNewColorOption({
//       ...newColorOption,
//       videoFile: null,
//       videoPreview: null,
//     });
//   };

//   const handleAddColorOption = () => {
//     if (!newColorOption.color || newColorOption.color.trim() === '') {
//       toast.error('Please enter a color name');
//       return;
//     }

//     if (!newColorOption.original_price || parseFloat(newColorOption.original_price) <= 0) {
//       toast.error('Please enter a valid original price for this color');
//       return;
//     }

//     if (!newColorOption.selling_price || parseFloat(newColorOption.selling_price) <= 0) {
//       toast.error('Please enter a valid selling price for this color');
//       return;
//     }

//     if (parseFloat(newColorOption.selling_price) > parseFloat(newColorOption.original_price)) {
//       toast.error('Selling price cannot be more than original price');
//       return;
//     }

//     if (newColorOption.sale_start_date && newColorOption.sale_end_date) {
//       if (new Date(newColorOption.sale_end_date) <= new Date(newColorOption.sale_start_date)) {
//         toast.error('Sale end date must be after sale start date');
//         return;
//       }
//     }

//     const colorData = {
//       color: newColorOption.color.trim(),
//       color_code: newColorOption.color_code || '#000000',
//       original_price: parseFloat(newColorOption.original_price),
//       selling_price: parseFloat(newColorOption.selling_price),
//       sale_start_date: newColorOption.sale_start_date || null,
//       sale_end_date: newColorOption.sale_end_date || null,
//       stock: parseInt(newColorOption.stock) || 0,
//       is_available: newColorOption.is_available !== false,
//       frontImage: newColorOption.frontImage,
//       backImage: newColorOption.backImage,
//       leftImage: newColorOption.leftImage,
//       rightImage: newColorOption.rightImage,
//       videoFile: newColorOption.videoFile,
//       frontPreview: newColorOption.frontPreview,
//       backPreview: newColorOption.backPreview,
//       leftPreview: newColorOption.leftPreview,
//       rightPreview: newColorOption.rightPreview,
//       videoPreview: newColorOption.videoPreview,
//     };

//     if (editingColorIndex !== null) {
//       const updatedColors = [...newProduct.colorOptions];
//       updatedColors[editingColorIndex] = colorData;
//       setNewProduct({ ...newProduct, colorOptions: updatedColors });
//       setEditingColorIndex(null);
//     } else {
//       setNewProduct({
//         ...newProduct,
//         colorOptions: [...newProduct.colorOptions, colorData],
//       });
//     }

//     resetColorForm();
//     setShowAddColorModal(false);
//     toast.success(editingColorIndex !== null ? 'Color updated' : 'Color added');
//   };

//   const resetColorForm = () => {
//     ['front', 'back', 'left', 'right'].forEach(type => {
//       if (newColorOption[`${type}Preview`]) {
//         URL.revokeObjectURL(newColorOption[`${type}Preview`]);
//       }
//     });
//     if (newColorOption.videoPreview) {
//       URL.revokeObjectURL(newColorOption.videoPreview);
//     }

//     setNewColorOption({
//       color: '',
//       color_code: '#000000',
//       original_price: '',
//       selling_price: '',
//       sale_start_date: '',
//       sale_end_date: '',
//       stock: '1',
//       is_available: true,
//       frontImage: null,
//       backImage: null,
//       leftImage: null,
//       rightImage: null,
//       videoFile: null,
//       frontPreview: null,
//       backPreview: null,
//       leftPreview: null,
//       rightPreview: null,
//       videoPreview: null,
//     });
//   };

//   const handleEditColorOption = (index) => {
//     const color = newProduct.colorOptions[index];
//     setNewColorOption({
//       color: color.color || '',
//       color_code: color.color_code || '#000000',
//       original_price: color.original_price?.toString() || '',
//       selling_price: color.selling_price?.toString() || '',
//       sale_start_date: color.sale_start_date || '',
//       sale_end_date: color.sale_end_date || '',
//       stock: color.stock?.toString() || '1',
//       is_available: color.is_available !== false,
//       frontImage: color.frontImage || null,
//       backImage: color.backImage || null,
//       leftImage: color.leftImage || null,
//       rightImage: color.rightImage || null,
//       videoFile: color.videoFile || null,
//       frontPreview: color.frontPreview || null,
//       backPreview: color.backPreview || null,
//       leftPreview: color.leftPreview || null,
//       rightPreview: color.rightPreview || null,
//       videoPreview: color.videoPreview || null,
//     });
//     setEditingColorIndex(index);
//     setShowAddColorModal(true);
//   };

//   const handleRemoveColorOption = (index) => {
//     const color = newProduct.colorOptions[index];
//     ['front', 'back', 'left', 'right'].forEach(type => {
//       if (color[`${type}Preview`]) {
//         URL.revokeObjectURL(color[`${type}Preview`]);
//       }
//     });
//     if (color.videoPreview) {
//       URL.revokeObjectURL(color.videoPreview);
//     }

//     const updatedColors = newProduct.colorOptions.filter((_, i) => i !== index);
//     setNewProduct({ ...newProduct, colorOptions: updatedColors });
//   };

//   // =============================================
//   // EDIT PRODUCT HANDLERS
//   // =============================================
//   const handleEditClick = (product) => {
//     setSelectedProduct(product);
//     setEditProduct({
//       name: product.name || '',
//       material: product.material || '',
//       category: product.category || '',
//       description: product.description || '',
//       how_it_works: product.how_it_works || '',
//       key_features: product.key_features || '',
//       length: product.length?.toString() || '',
//       width: product.width?.toString() || '',
//       height: product.height?.toString() || '',
//       dimension_unit: product.dimension_unit || 'cm',
//       weight: product.weight?.toString() || '',
//       weight_unit: product.weight_unit || 'kg',
//       location: product.location || '',
//       is_available: product.is_available !== false,
//     });

//     if (product.variants && product.variants.length > 0) {
//       setEditVariants(product.variants.map(v => ({
//         ...v,
//         _original: { ...v }
//       })));
//     } else {
//       setEditVariants([]);
//     }

//     setShowEditModal(true);
//   };

//   // Edit variant handlers
//   const handleEditVariantClick = (index) => {
//     const variant = editVariants[index];
//     setEditingVariantIndex(index);
//     setEditingVariantId(variant.id);
//     setEditVariant({
//       color_name: variant.color_name || '',
//       color_code: variant.color_code || '#000000',
//       original_price: variant.original_price?.toString() || '',
//       selling_price: variant.selling_price?.toString() || '',
//       sale_start_date: variant.sale_start_date || '',
//       sale_end_date: variant.sale_end_date || '',
//       stock: variant.stock?.toString() || '1',
//       is_available: variant.is_available !== false,
//     });
//     setShowEditVariantModal(true);
//   };

//   const handleUpdateVariant = () => {
//     if (!editVariant.color_name || editVariant.color_name.trim() === '') {
//       toast.error('Please enter a color name');
//       return;
//     }

//     if (!editVariant.original_price || parseFloat(editVariant.original_price) <= 0) {
//       toast.error('Please enter a valid original price');
//       return;
//     }

//     if (!editVariant.selling_price || parseFloat(editVariant.selling_price) <= 0) {
//       toast.error('Please enter a valid selling price');
//       return;
//     }

//     if (parseFloat(editVariant.selling_price) > parseFloat(editVariant.original_price)) {
//       toast.error('Selling price cannot be more than original price');
//       return;
//     }

//     if (editVariant.sale_start_date && editVariant.sale_end_date) {
//       if (new Date(editVariant.sale_end_date) <= new Date(editVariant.sale_start_date)) {
//         toast.error('Sale end date must be after sale start date');
//         return;
//       }
//     }

//     const updatedVariants = [...editVariants];
//     updatedVariants[editingVariantIndex] = {
//       ...updatedVariants[editingVariantIndex],
//       color_name: editVariant.color_name.trim(),
//       color_code: editVariant.color_code || '#000000',
//       original_price: parseFloat(editVariant.original_price),
//       selling_price: parseFloat(editVariant.selling_price),
//       sale_start_date: editVariant.sale_start_date || null,
//       sale_end_date: editVariant.sale_end_date || null,
//       stock: parseInt(editVariant.stock) || 0,
//       is_available: editVariant.is_available !== false,
//     };

//     setEditVariants(updatedVariants);
//     setShowEditVariantModal(false);
//     toast.success('Variant updated successfully');
//   };

//   const handleRemoveEditVariant = (index) => {
//     if (editVariants.length <= 1) {
//       toast.error('Product must have at least one color option');
//       return;
//     }
//     const updatedVariants = editVariants.filter((_, i) => i !== index);
//     setEditVariants(updatedVariants);
//     toast.success('Variant removed');
//   };

//   const handleAddEditVariant = () => {
//     setEditingVariantIndex(null);
//     setEditingVariantId(null);
//     setEditVariant({
//       color_name: '',
//       color_code: '#000000',
//       original_price: '',
//       selling_price: '',
//       sale_start_date: '',
//       sale_end_date: '',
//       stock: '1',
//       is_available: true,
//     });
//     setShowEditVariantModal(true);
//   };

//   const handleSaveEditVariant = () => {
//     if (!editVariant.color_name || editVariant.color_name.trim() === '') {
//       toast.error('Please enter a color name');
//       return;
//     }

//     if (!editVariant.original_price || parseFloat(editVariant.original_price) <= 0) {
//       toast.error('Please enter a valid original price');
//       return;
//     }

//     if (!editVariant.selling_price || parseFloat(editVariant.selling_price) <= 0) {
//       toast.error('Please enter a valid selling price');
//       return;
//     }

//     if (parseFloat(editVariant.selling_price) > parseFloat(editVariant.original_price)) {
//       toast.error('Selling price cannot be more than original price');
//       return;
//     }

//     if (editVariant.sale_start_date && editVariant.sale_end_date) {
//       if (new Date(editVariant.sale_end_date) <= new Date(editVariant.sale_start_date)) {
//         toast.error('Sale end date must be after sale start date');
//         return;
//       }
//     }

//     const newVariant = {
//       id: null,
//       color_name: editVariant.color_name.trim(),
//       color_code: editVariant.color_code || '#000000',
//       original_price: parseFloat(editVariant.original_price),
//       selling_price: parseFloat(editVariant.selling_price),
//       sale_start_date: editVariant.sale_start_date || null,
//       sale_end_date: editVariant.sale_end_date || null,
//       stock: parseInt(editVariant.stock) || 0,
//       is_available: editVariant.is_available !== false,
//       images: [],
//       video: null,
//     };

//     setEditVariants([...editVariants, newVariant]);
//     setShowEditVariantModal(false);
//     toast.success('New variant added');
//   };

//   const handleUpdateProduct = async () => {
//     if (!selectedProduct) return;

//     try {
//       setActionLoading((prev) => ({ ...prev, edit: true }));

//       const updateData = {
//         name: editProduct.name,
//         material: editProduct.material,
//         category: editProduct.category,
//         description: editProduct.description,
//         how_it_works: editProduct.how_it_works,
//         key_features: editProduct.key_features,
//         length: editProduct.length || '0',
//         width: editProduct.width || '0',
//         height: editProduct.height || '0',
//         dimension_unit: editProduct.dimension_unit,
//         weight: editProduct.weight || '0',
//         weight_unit: editProduct.weight_unit,
//         location: editProduct.location,
//         is_available: editProduct.is_available,
//       };

//       await serverUrlAuth.patch(
//         `projects/ready-made-products/${selectedProduct.id}/`,
//         updateData,
//       );

//       const originalVariants = selectedProduct.variants || [];
      
//       for (const variant of editVariants) {
//         if (variant.id) {
//           const variantData = {
//             color_name: variant.color_name,
//             color_code: variant.color_code,
//             original_price: variant.original_price,
//             selling_price: variant.selling_price,
//             sale_start_date: variant.sale_start_date,
//             sale_end_date: variant.sale_end_date,
//             stock: variant.stock,
//             is_available: variant.is_available,
//           };
          
//           try {
//             await serverUrlAuth.patch(
//               `projects/product-variants/${variant.id}/`,
//               variantData,
//             );
//           } catch (err) {
//             console.error(`Error updating variant ${variant.id}:`, err);
//           }
//         } else {
//           const formData = new FormData();
//           formData.append('product', selectedProduct.id);
//           formData.append('color_name', variant.color_name);
//           formData.append('color_code', variant.color_code || '#000000');
//           formData.append('original_price', variant.original_price);
//           formData.append('selling_price', variant.selling_price);
//           formData.append('stock', variant.stock);
//           formData.append('is_available', variant.is_available ? 'true' : 'false');
//           if (variant.sale_start_date) {
//             formData.append('sale_start_date', variant.sale_start_date);
//           }
//           if (variant.sale_end_date) {
//             formData.append('sale_end_date', variant.sale_end_date);
//           }

//           try {
//             await serverUrlAuth.post(
//               `projects/product-variants/`,
//               formData,
//               { headers: { 'Content-Type': 'multipart/form-data' } }
//             );
//           } catch (err) {
//             console.error('Error creating variant:', err);
//           }
//         }
//       }

//       const originalIds = originalVariants.map(v => v.id);
//       const currentIds = editVariants.filter(v => v.id).map(v => v.id);
//       const deletedIds = originalIds.filter(id => !currentIds.includes(id));

//       for (const id of deletedIds) {
//         try {
//           await serverUrlAuth.delete(`projects/product-variants/${id}/`);
//         } catch (err) {
//           console.error(`Error deleting variant ${id}:`, err);
//         }
//       }

//       await fetchProducts();
//       setShowEditModal(false);
//       toast.success('Product updated successfully');
//     } catch (error) {
//       console.error('Error updating product:', error);
//       toast.error(error.response?.data?.message || 'Failed to update product');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, edit: false }));
//     }
//   };

//   const handleViewClick = (product) => {
//     setSelectedProduct(product);
//     setShowViewModal(true);
//   };

//   const handleDeleteClick = (product) => {
//     setProductToDelete(product);
//     setShowDeleteModal(true);
//   };

//   const handleDeleteProduct = async () => {
//     if (!productToDelete) return;

//     try {
//       setActionLoading((prev) => ({ ...prev, delete: true }));
//       await serverUrlAuth.delete(
//         `projects/ready-made-products/${productToDelete.id}/`,
//       );
//       setProducts(products.filter((p) => p.id !== productToDelete.id));
//       setShowDeleteModal(false);
//       setProductToDelete(null);
//       toast.success('Product deleted successfully');
//     } catch (error) {
//       console.error('Error deleting product:', error);
//       toast.error('Failed to delete product');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, delete: false }));
//     }
//   };

//   const handleToggleStatus = async (productId) => {
//     const product = products.find((p) => p.id === productId);
//     try {
//       setActionLoading((prev) => ({ ...prev, toggleStatus: true }));
//       const response = await serverUrlAuth.patch(
//         `projects/ready-made-products/${productId}/`,
//         { is_available: !product.is_available },
//       );
//       setProducts(
//         products.map((p) =>
//           p.id === productId
//             ? { ...p, is_available: response.data.is_available }
//             : p,
//         ),
//       );
//       toast.success(
//         `Product ${response.data.is_available ? 'activated' : 'deactivated'}`,
//       );
//     } catch (error) {
//       console.error('Error toggling product status:', error);
//       toast.error('Failed to update product status');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, toggleStatus: false }));
//     }
//   };

//   const handleAddProduct = async () => {
//     if (!newProduct.name || newProduct.name.trim() === '') {
//       toast.error('Please enter a product name');
//       return;
//     }

//     if (newProduct.colorOptions.length === 0) {
//       toast.error('Please add at least one color option');
//       return;
//     }

//     for (const color of newProduct.colorOptions) {
//       if (!color.color || color.color.trim() === '') {
//         toast.error('All colors must have a name');
//         return;
//       }
//       if (!color.original_price || parseFloat(color.original_price) <= 0) {
//         toast.error(`Color "${color.color}" needs an original price`);
//         return;
//       }
//       if (!color.selling_price || parseFloat(color.selling_price) <= 0) {
//         toast.error(`Color "${color.color}" needs a selling price`);
//         return;
//       }
//       if (parseFloat(color.selling_price) > parseFloat(color.original_price)) {
//         toast.error(`Color "${color.color}" selling price cannot be more than original price`);
//         return;
//       }
//       if (color.sale_start_date && color.sale_end_date) {
//         if (new Date(color.sale_end_date) <= new Date(color.sale_start_date)) {
//           toast.error(`Color "${color.color}" sale end date must be after start date`);
//           return;
//         }
//       }
//     }

//     const formData = new FormData();
    
//     formData.append('name', newProduct.name.trim());
//     formData.append('material', newProduct.material);
//     formData.append('category', newProduct.category);
//     formData.append('description', newProduct.description || '');
//     formData.append('how_it_works', newProduct.how_it_works || '');
//     formData.append('key_features', newProduct.key_features || '');
//     formData.append('length', newProduct.length || '0');
//     formData.append('width', newProduct.width || '0');
//     formData.append('height', newProduct.height || '0');
//     formData.append('dimension_unit', newProduct.dimension_unit);
//     formData.append('weight', newProduct.weight || '0');
//     formData.append('weight_unit', newProduct.weight_unit);
//     formData.append('location', newProduct.location || '');
//     formData.append('is_available', newProduct.is_available ? 'true' : 'false');

//     newProduct.colorOptions.forEach((color, index) => {
//       formData.append(`variants[${index}][color_name]`, color.color.trim());
//       formData.append(`variants[${index}][color_code]`, color.color_code || '#000000');
//       formData.append(`variants[${index}][original_price]`, color.original_price);
//       formData.append(`variants[${index}][selling_price]`, color.selling_price);
//       formData.append(`variants[${index}][stock]`, parseInt(color.stock) || 0);
//       formData.append(`variants[${index}][is_available]`, color.is_available !== false ? 'true' : 'false');
      
//       if (color.sale_start_date) {
//         formData.append(`variants[${index}][sale_start_date]`, color.sale_start_date);
//       }
//       if (color.sale_end_date) {
//         formData.append(`variants[${index}][sale_end_date]`, color.sale_end_date);
//       }

//       ['front', 'back', 'left', 'right'].forEach(type => {
//         if (color[`${type}Image`]) {
//           formData.append(`variants[${index}][${type}]`, color[`${type}Image`]);
//         }
//       });

//       if (color.videoFile) {
//         formData.append(`variants[${index}][video]`, color.videoFile);
//       }
//     });

//     try {
//       setActionLoading((prev) => ({ ...prev, add: true }));
//       const response = await serverUrlAuth.post(
//         'projects/ready-made-products/',
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       );
//       setProducts([response.data, ...products]);
//       setShowAddModal(false);
//       resetProductForm();
//       toast.success('Product added successfully');
//     } catch (error) {
//       console.error('Error adding product:', error);
//       let errorMsg = 'Failed to add product';
//       if (error.response?.data) {
//         if (typeof error.response.data === 'object') {
//           const errors = Object.entries(error.response.data)
//             .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
//             .join('\n');
//           errorMsg = errors || JSON.stringify(error.response.data);
//         } else {
//           errorMsg = error.response.data;
//         }
//       }
//       toast.error(errorMsg);
//     } finally {
//       setActionLoading((prev) => ({ ...prev, add: false }));
//     }
//   };

//   const resetProductForm = () => {
//     newProduct.colorOptions.forEach(color => {
//       ['front', 'back', 'left', 'right'].forEach(type => {
//         if (color[`${type}Preview`]) {
//           URL.revokeObjectURL(color[`${type}Preview`]);
//         }
//       });
//       if (color.videoPreview) {
//         URL.revokeObjectURL(color.videoPreview);
//       }
//     });

//     setNewProduct({
//       name: '',
//       material: 'wood',
//       category: 'furniture',
//       description: '',
//       how_it_works: '',
//       key_features: '',
//       length: '',
//       width: '',
//       height: '',
//       dimension_unit: 'cm',
//       weight: '',
//       weight_unit: 'kg',
//       location: '',
//       is_available: true,
//       colorOptions: [],
//     });
    
//     resetColorForm();
//     setEditingColorIndex(null);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//     });
//   };

//   const getMaterialLabel = (value) => {
//     const choice = MATERIAL_CHOICES.find(c => c.value === value);
//     return choice ? choice.label : value;
//   };

//   const getCategoryLabel = (value) => {
//     const choice = CATEGORY_CHOICES.find(c => c.value === value);
//     return choice ? choice.label : value;
//   };

//   const getTotalStock = (product) => {
//     if (!product.variants) return 0;
//     return product.variants.reduce((sum, v) => sum + (v.stock || 0), 0);
//   };

//   const getTotalSold = (product) => {
//     if (!product.variants) return 0;
//     return product.variants.reduce((sum, v) => sum + (v.sold_count || 0), 0);
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="loading-spinner">
//           <FaSpinner className="spinner" />
//           <p>Loading products...</p>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="artisan-ready-products">
//         <div className="products-container">
//           {/* Header */}
//           <div className="products-header">
//             <div className="header-left">
//               <h1>My Products</h1>
//               <div className="shop-status">
//                 <span className="products-count">
//                   <span>{products.length}</span> products
//                 </span>
//               </div>
//             </div>
//             <div className="header-actions">
//               <button
//                 className="add-product-btn"
//                 onClick={() => setShowAddModal(true)}
//               >
//                 <FaPlus /> Add New Product
//               </button>
//             </div>
//           </div>

//           {/* Stats Cards */}
//           <div className="shop-stats">
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaBoxes />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">{shopStats.totalProducts}</div>
//                 <div className="stat-label">Total Products</div>
//               </div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaEye />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">{shopStats.activeProducts}</div>
//                 <div className="stat-label">In Stock</div>
//               </div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaShoppingBag />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">{shopStats.totalSales}</div>
//                 <div className="stat-label">Items Sold</div>
//               </div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaDollarSign />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">
//                   {formatCurrency(shopStats.totalRevenue)}
//                 </div>
//                 <div className="stat-label">Total Sales</div>
//               </div>
//             </div>
//           </div>

//           {/* Search and Filters */}
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch />
//               <input
//                 type="text"
//                 placeholder="Search products..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>
//             <div className="filter-actions">
//               <select
//                 className="filter-select"
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//               >
//                 <option value="all">All</option>
//                 <option value="active">Available</option>
//                 <option value="inactive">Unavailable</option>
//               </select>
//               <div className="view-toggle">
//                 <button
//                   className={viewMode === 'grid' ? 'active' : ''}
//                   onClick={() => setViewMode('grid')}
//                 >
//                   <FaThLarge />
//                 </button>
//                 <button
//                   className={viewMode === 'list' ? 'active' : ''}
//                   onClick={() => setViewMode('list')}
//                 >
//                   <FaList />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Products Display */}
//           {filteredProducts.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">
//                 <FaBoxes />
//               </div>
//               <h2>No products yet</h2>
//               <p>Start selling by adding your first product</p>
//               <button
//                 className="add-first-btn"
//                 onClick={() => setShowAddModal(true)}
//               >
//                 <FaPlus /> Add Your First Product
//               </button>
//             </div>
//           ) : (
//             <div className={`products-grid ${viewMode === 'list' ? 'list-view' : ''}`}>
//               {filteredProducts.map((product) => {
//                 const totalStock = getTotalStock(product);
//                 const totalSold = getTotalSold(product);
//                 const priceRange = getPriceRange(product);
//                 const isOnSale = isProductOnSale(product);
//                 const discountPercent = getProductDiscount(product);
                
//                 return (
//                   <div key={product.id} className="product-card">
//                     <div className="product-image">
//                       {product.variants && product.variants.length > 0 && 
//                        product.variants[0].images && product.variants[0].images.length > 0 ? (
//                         <img
//                           src={product.variants[0].images[0].image_url}
//                           alt={product.name}
//                         />
//                       ) : (
//                         <div className="image-placeholder">
//                           <FaImage />
//                         </div>
//                       )}
//                       {isOnSale && discountPercent > 0 && (
//                         <div className="sale-badge">-{discountPercent}%</div>
//                       )}
//                       {totalStock === 0 && (
//                         <div className="stock-overlay">Out of Stock</div>
//                       )}
//                       {totalStock > 0 && totalStock <= 2 && (
//                         <div className="stock-overlay low-stock">
//                           Low Stock: {totalStock} left
//                         </div>
//                       )}
//                     </div>
//                     <div className="product-info">
//                       <div className="product-code">{product.code}</div>
//                       <h3 className="product-name">{product.name}</h3>
//                       <div className="product-meta">
//                         <span className="material-badge">
//                           {getMaterialLabel(product.material)}
//                         </span>
//                         <span className="category-badge">
//                           {getCategoryLabel(product.category)}
//                         </span>
//                       </div>
//                       {/* ✅ FIXED: Show correct price - original when not on sale */}
//                       <div className="product-pricing">
//                         <span className="current-price">
//                           {priceRange}
//                         </span>
//                         {isOnSale && (
//                           <span className="sale-badge-text">ON SALE</span>
//                         )}
//                       </div>
//                       <div className="product-stats">
//                         <span>
//                           <FaBoxes /> Stock: {totalStock}
//                         </span>
//                         <span>
//                           <FaShoppingBag /> Sold: {totalSold}
//                         </span>
//                         {product.variants && (
//                           <span>
//                             <FaPalette /> {product.variants.length} colors
//                           </span>
//                         )}
//                       </div>
//                       <div className="product-dimensions">
//                         <FaRulerCombined /> {product.dimensions}
//                       </div>
//                       <p className="product-description">
//                         {product.description?.substring(0, 100)}
//                         {product.description?.length > 100 ? '...' : ''}
//                       </p>
//                     </div>
//                     <div className="product-actions">
//                       <button
//                         className="view-btn"
//                         onClick={() => handleViewClick(product)}
//                       >
//                         <FaEye /> View
//                       </button>
//                       <button
//                         className="edit-btn"
//                         onClick={() => handleEditClick(product)}
//                         disabled={actionLoading.edit}
//                       >
//                         <FaEdit /> Edit
//                       </button>
//                       <button
//                         className="edit-btn delete-btn"
//                         onClick={() => handleDeleteClick(product)}
//                         disabled={actionLoading.delete}
//                       >
//                         {actionLoading.delete ? (
//                           <FaSpinner className="spinner" />
//                         ) : (
//                           <FaTrash />
//                         )}{' '}
//                         Delete
//                       </button>
//                       <button
//                         className={`toggle-btn ${product.is_available ? '' : 'inactive'}`}
//                         onClick={() => handleToggleStatus(product.id)}
//                         disabled={actionLoading.toggleStatus}
//                       >
//                         {product.is_available ? 'Out of Stock' : 'In Stock'}
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>

//         {/* ============================================= */}
//         {/* VIEW PRODUCT MODAL - WITH VIDEO & LIGHTBOX */}
//         {/* ============================================= */}
//         <Modal
//           show={showViewModal}
//           onHide={() => setShowViewModal(false)}
//           size="xl"
//           centered
//           className="view-product-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Product Details</h2>
//           </Modal.Header>
//           <Modal.Body>
//             {selectedProduct && (
//               <div className="view-product-content">
//                 <div className="view-product-header">
//                   <div className="view-product-image-main">
//                     {selectedProduct.variants && selectedProduct.variants.length > 0 && 
//                      selectedProduct.variants[0].images && selectedProduct.variants[0].images.length > 0 ? (
//                       <img
//                         src={selectedProduct.variants[0].images[0].image_url}
//                         alt={selectedProduct.name}
//                       />
//                     ) : (
//                       <div className="image-placeholder-large">
//                         <FaImage />
//                       </div>
//                     )}
//                   </div>
//                   <div className="view-product-summary">
//                     <div className="product-code-badge">{selectedProduct.code}</div>
//                     <h1 className="view-product-name">{selectedProduct.name}</h1>
//                     <div className="view-product-meta">
//                       <span className="material-badge">
//                         {getMaterialLabel(selectedProduct.material)}
//                       </span>
//                       <span className="category-badge">
//                         {getCategoryLabel(selectedProduct.category)}
//                       </span>
//                       <span className={`status-badge ${selectedProduct.is_available ? 'active' : 'inactive'}`}>
//                         {selectedProduct.is_available ? (
//                           <><FaCheckCircle /> Available</>
//                         ) : (
//                           <><FaTimesCircle /> Unavailable</>
//                         )}
//                       </span>
//                     </div>
//                     {/* ✅ FIXED: Show correct price range */}
//                     <div className="view-product-price">
//                       <span className="price-main">
//                         {getPriceRange(selectedProduct)}
//                       </span>
//                     </div>
//                     <div className="view-product-quick-stats">
//                       <div className="quick-stat">
//                         <FaBoxes />
//                         <span><strong>{getTotalStock(selectedProduct)}</strong> in stock</span>
//                       </div>
//                       <div className="quick-stat">
//                         <FaShoppingBag />
//                         <span><strong>{getTotalSold(selectedProduct)}</strong> sold</span>
//                       </div>
//                       <div className="quick-stat">
//                         <FaPalette />
//                         <span><strong>{selectedProduct.variants?.length || 0}</strong> colors</span>
//                       </div>
//                       <div className="quick-stat">
//                         <FaCalendarAlt />
//                         <span>Added {formatDate(selectedProduct.created_at)}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="view-product-details-grid">
//                   <div className="view-details-left">
//                     <div className="view-section">
//                       <h4><FaInfoCircle /> Description</h4>
//                       <p>{selectedProduct.description || 'No description provided'}</p>
//                     </div>

//                     {selectedProduct.how_it_works && (
//                       <div className="view-section">
//                         <h4>How It Works</h4>
//                         <p>{selectedProduct.how_it_works}</p>
//                       </div>
//                     )}

//                     {selectedProduct.key_features && (
//                       <div className="view-section">
//                         <h4>Key Features</h4>
//                         <p>{selectedProduct.key_features}</p>
//                       </div>
//                     )}

//                     <div className="view-section">
//                       <h4><FaRulerCombined /> Size & Weight</h4>
//                       <div className="view-dimensions">
//                         <div className="dimension-item">
//                           <span className="dimension-label">Size</span>
//                           <span className="dimension-value">{selectedProduct.dimensions}</span>
//                         </div>
//                         {selectedProduct.weight && (
//                           <div className="dimension-item">
//                             <span className="dimension-label">Weight</span>
//                             <span className="dimension-value">
//                               {selectedProduct.weight} {selectedProduct.weight_unit}
//                             </span>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {selectedProduct.location && (
//                       <div className="view-section">
//                         <h4><FaStore /> Location</h4>
//                         <p>{selectedProduct.location}</p>
//                       </div>
//                     )}
//                   </div>

//                   <div className="view-details-right">
//                     <div className="view-section">
//                       <h4><FaPalette /> Colors / Options</h4>
//                       {selectedProduct.variants && selectedProduct.variants.length > 0 ? (
//                         <div className="view-variants-list">
//                           {selectedProduct.variants.map((variant, index) => (
//                             <div key={variant.id || index} className="view-variant-item">
//                               <div className="view-variant-header">
//                                 <div className="view-variant-color">
//                                   <span
//                                     className="color-dot-large"
//                                     style={{ backgroundColor: variant.color_code || '#000000' }}
//                                   />
//                                   <span className="view-variant-name">{variant.color_name}</span>
//                                   <span className={`variant-status ${variant.is_available ? 'available' : 'unavailable'}`}>
//                                     {variant.is_available ? 'Available' : 'Unavailable'}
//                                   </span>
//                                 </div>
//                                 {/* ✅ FIXED: Show correct price based on sale status */}
//                                 <div className="view-variant-price">
//                                   <span className="variant-selling-price">
//                                     {variant.is_on_sale ? formatCurrency(variant.selling_price) : formatCurrency(variant.original_price)}
//                                   </span>
//                                   {variant.is_on_sale && variant.original_price && variant.selling_price && (
//                                     <span className="variant-original-price">
//                                       {formatCurrency(variant.original_price)}
//                                     </span>
//                                   )}
//                                   {variant.is_on_sale && (
//                                     <span className="variant-sale-badge">ON SALE</span>
//                                   )}
//                                 </div>
//                               </div>
//                               <div className="view-variant-details">
//                                 <div className="variant-stock-info">
//                                   <FaBoxes /> Stock: <strong>{variant.stock || 0}</strong>
//                                   {variant.sold_count > 0 && (
//                                     <span className="variant-sold"> | Sold: {variant.sold_count}</span>
//                                   )}
//                                 </div>
//                                 {variant.sale_start_date && variant.sale_end_date && (
//                                   <div className="variant-sale-dates">
//                                     <FaTag /> Sale: {formatDate(variant.sale_start_date)} - {formatDate(variant.sale_end_date)}
//                                   </div>
//                                 )}
                                
//                                 <div className="variant-media-container">
//                                   {variant.images && variant.images.length > 0 && (
//                                     <div className="variant-images-row">
//                                       {variant.images.map((img, imgIndex) => (
//                                         <div key={imgIndex} className="variant-image-thumb-wrapper">
//                                           <img
//                                             src={img.image_url}
//                                             alt={`${variant.color_name} ${img.image_type || ''}`}
//                                             className="variant-thumb"
//                                             onClick={() => {
//                                               window.open(img.image_url, '_blank');
//                                             }}
//                                           />
//                                           {img.image_type && (
//                                             <span className="image-type-tag">{img.image_type}</span>
//                                           )}
//                                         </div>
//                                       ))}
//                                     </div>
//                                   )}

//                                   {variant.video && variant.video.video_url && (
//                                     <div className="variant-video-container">
//                                       <div className="variant-video-wrapper">
//                                         <video 
//                                           controls 
//                                           className="variant-video-player"
//                                           poster={variant.images && variant.images.length > 0 ? variant.images[0].image_url : null}
//                                         >
//                                           <source src={variant.video.video_url} type="video/mp4" />
//                                           Your browser does not support the video tag.
//                                         </video>
//                                         <div className="video-badge">
//                                           <FaVideo /> Video
//                                         </div>
//                                       </div>
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <div className="no-variants-view">
//                           <FaPalette />
//                           <p>No color options available</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => setShowViewModal(false)}
//             >
//               Close
//             </button>
//             {selectedProduct && (
//               <button
//                 className="btn btn-primary"
//                 onClick={() => {
//                   setShowViewModal(false);
//                   handleEditClick(selectedProduct);
//                 }}
//               >
//                 <FaEdit /> Edit Product
//               </button>
//             )}
//           </Modal.Footer>
//         </Modal>

//         {/* ============================================= */}
//         {/* EDIT PRODUCT MODAL - WITH VARIANT EDITING */}
//         {/* ============================================= */}
//         <Modal
//           show={showEditModal}
//           onHide={() => setShowEditModal(false)}
//           size="xl"
//           centered
//           className="edit-product-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Edit Product</h2>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="edit-product-content">
//               {/* Product Info Section */}
//               <div className="edit-product-section">
//                 <h3>Product Details</h3>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Product Name</label>
//                     <input
//                       type="text"
//                       value={editProduct.name}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, name: e.target.value })
//                       }
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Code</label>
//                     <input
//                       type="text"
//                       value={selectedProduct?.code || ''}
//                       disabled
//                       className="disabled-input"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Material</label>
//                     <select
//                       value={editProduct.material}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, material: e.target.value })
//                       }
//                     >
//                       {MATERIAL_CHOICES.map((choice) => (
//                         <option key={choice.value} value={choice.value}>
//                           {choice.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="form-group">
//                     <label>Category</label>
//                     <select
//                       value={editProduct.category}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, category: e.target.value })
//                       }
//                     >
//                       {CATEGORY_CHOICES.map((choice) => (
//                         <option key={choice.value} value={choice.value}>
//                           {choice.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     value={editProduct.description}
//                     onChange={(e) =>
//                       setEditProduct({
//                         ...editProduct,
//                         description: e.target.value,
//                       })
//                     }
//                     rows="3"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>How It Works</label>
//                   <textarea
//                     value={editProduct.how_it_works}
//                     onChange={(e) =>
//                       setEditProduct({
//                         ...editProduct,
//                         how_it_works: e.target.value,
//                       })
//                     }
//                     rows="2"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Key Features</label>
//                   <textarea
//                     value={editProduct.key_features}
//                     onChange={(e) =>
//                       setEditProduct({
//                         ...editProduct,
//                         key_features: e.target.value,
//                       })
//                     }
//                     rows="2"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Location</label>
//                   <input
//                     type="text"
//                     value={editProduct.location}
//                     onChange={(e) =>
//                       setEditProduct({ ...editProduct, location: e.target.value })
//                     }
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Dimensions</label>
//                   <div className="dimension-input-group">
//                     <input
//                       type="number"
//                       value={editProduct.length}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, length: e.target.value })
//                       }
//                       placeholder="L"
//                       step="0.01"
//                     />
//                     <span>×</span>
//                     <input
//                       type="number"
//                       value={editProduct.width}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, width: e.target.value })
//                       }
//                       placeholder="W"
//                       step="0.01"
//                     />
//                     <span>×</span>
//                     <input
//                       type="number"
//                       value={editProduct.height}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, height: e.target.value })
//                       }
//                       placeholder="H"
//                       step="0.01"
//                     />
//                     <select
//                       value={editProduct.dimension_unit}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, dimension_unit: e.target.value })
//                       }
//                     >
//                       {DIMENSION_UNIT_CHOICES.map((choice) => (
//                         <option key={choice.value} value={choice.value}>
//                           {choice.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 <div className="form-group checkbox-group">
//                   <label>
//                     <input
//                       type="checkbox"
//                       checked={editProduct.is_available}
//                       onChange={(e) =>
//                         setEditProduct({ ...editProduct, is_available: e.target.checked })
//                       }
//                     />
//                     Available for purchase
//                   </label>
//                 </div>
//               </div>

//               {/* Variants Section */}
//               <div className="edit-variants-section">
//                 <div className="edit-variants-header">
//                   <h3>Colors / Options</h3>
//                   <button
//                     type="button"
//                     className="add-variant-btn"
//                     onClick={handleAddEditVariant}
//                   >
//                     <FaPlus /> Add Color
//                   </button>
//                 </div>
//                 <p className="edit-variant-note">
//                   Edit each color's price, stock, and sale information
//                 </p>

//                 {editVariants.length === 0 ? (
//                   <div className="no-variants-edit">
//                     <FaPalette />
//                     <p>No colors added yet. Click "Add Color" to get started.</p>
//                   </div>
//                 ) : (
//                   <div className="edit-variants-list">
//                     {editVariants.map((variant, index) => (
//                       <div key={variant.id || index} className="edit-variant-item">
//                         <div className="edit-variant-info">
//                           <div className="edit-variant-color">
//                             <span
//                               className="color-dot"
//                               style={{ backgroundColor: variant.color_code || '#000000' }}
//                             />
//                             <span className="color-name">{variant.color_name}</span>
//                             <span className={`variant-status-badge ${variant.is_available ? 'available' : 'unavailable'}`}>
//                               {variant.is_available ? 'Available' : 'Unavailable'}
//                             </span>
//                             {variant.sale_start_date && variant.sale_end_date && (
//                               <span className="sale-badge-small">On Sale</span>
//                             )}
//                           </div>
//                           <div className="edit-variant-pricing">
//                             <span className="edit-price-selling">
//                               {formatCurrency(variant.selling_price)}
//                             </span>
//                             {variant.original_price && variant.selling_price && 
//                              variant.selling_price < variant.original_price && (
//                               <span className="edit-price-original">
//                                 {formatCurrency(variant.original_price)}
//                               </span>
//                             )}
//                             <span className="edit-variant-stock">
//                               Stock: {variant.stock}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="edit-variant-actions">
//                           <button
//                             type="button"
//                             className="edit-variant-btn"
//                             onClick={() => handleEditVariantClick(index)}
//                           >
//                             <FaEdit />
//                           </button>
//                           <button
//                             type="button"
//                             className="remove-variant-btn"
//                             onClick={() => handleRemoveEditVariant(index)}
//                             disabled={editVariants.length <= 1}
//                           >
//                             <FaTrash />
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => setShowEditModal(false)}
//               disabled={actionLoading.edit}
//             >
//               Cancel
//             </button>
//             <button
//               className="btn btn-primary"
//               onClick={handleUpdateProduct}
//               disabled={actionLoading.edit}
//             >
//               {actionLoading.edit ? (
//                 <>
//                   <FaSpinner className="spinner" /> Saving...
//                 </>
//               ) : (
//                 'Save Changes'
//               )}
//             </button>
//           </Modal.Footer>
//         </Modal>

//         {/* ============================================= */}
//         {/* EDIT VARIANT MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showEditVariantModal}
//           onHide={() => {
//             setShowEditVariantModal(false);
//             setEditingVariantIndex(null);
//             setEditingVariantId(null);
//           }}
//           size="lg"
//           centered
//           className="variant-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>{editingVariantIndex !== null && editingVariantId ? 'Edit' : 'Add'} Color Option</h2>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="variant-form-grid">
//               <div className="variant-form-left">
//                 <div className="form-group">
//                   <label>
//                     Color Name <span className="required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     value={editVariant.color_name}
//                     onChange={(e) =>
//                       setEditVariant({ ...editVariant, color_name: e.target.value })
//                     }
//                     placeholder="e.g., Brown, Black, White"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Color Code (HEX)</label>
//                   <div className="color-input-group">
//                     <input
//                       type="color"
//                       value={editVariant.color_code}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, color_code: e.target.value })
//                       }
//                     />
//                     <input
//                       type="text"
//                       value={editVariant.color_code}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, color_code: e.target.value })
//                       }
//                       placeholder="#RRGGBB"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>
//                       Original Price (KSh) <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       value={editVariant.original_price}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, original_price: e.target.value })
//                       }
//                       placeholder="e.g., 8000"
//                       min="0"
//                       step="0.01"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>
//                       Selling Price (KSh) <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       value={editVariant.selling_price}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, selling_price: e.target.value })
//                       }
//                       placeholder="e.g., 8000"
//                       min="0"
//                       step="0.01"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>
//                       Stock <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       value={editVariant.stock}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, stock: e.target.value })
//                       }
//                       min="0"
//                     />
//                   </div>
//                   <div className="form-group checkbox-group">
//                     <label>
//                       <input
//                         type="checkbox"
//                         checked={editVariant.is_available}
//                         onChange={(e) =>
//                           setEditVariant({ ...editVariant, is_available: e.target.checked })
//                         }
//                       />
//                       Available
//                     </label>
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Sale Start Date (Optional)</label>
//                     <input
//                       type="datetime-local"
//                       value={editVariant.sale_start_date}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, sale_start_date: e.target.value })
//                       }
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Sale End Date (Optional)</label>
//                     <input
//                       type="datetime-local"
//                       value={editVariant.sale_end_date}
//                       onChange={(e) =>
//                         setEditVariant({ ...editVariant, sale_end_date: e.target.value })
//                       }
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="variant-form-right">
//                 <div className="form-group">
//                   <label>Images</label>
//                   <div className="image-upload-grid">
//                     {['front', 'back', 'left', 'right'].map((type) => (
//                       <div key={type} className="image-upload-item">
//                         <label className="image-type-label">
//                           {IMAGE_LABELS[type]}
//                         </label>
//                         <div className="image-upload-box">
//                           <label className="upload-box-label">
//                             <FaUpload />
//                             <span>Upload</span>
//                             <small>Current: {editVariant[`${type}Image`] ? '1' : '0'}</small>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) => {
//                                 const file = e.target.files[0];
//                                 if (file) {
//                                   setEditVariant({
//                                     ...editVariant,
//                                     [`${type}Image`]: file,
//                                     [`${type}Preview`]: URL.createObjectURL(file),
//                                   });
//                                 }
//                               }}
//                               style={{ display: 'none' }}
//                             />
//                           </label>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="form-group">
//                   <label>Video (Optional)</label>
//                   <div className="video-upload-box">
//                     <label className="upload-box-label video">
//                       <FaUpload />
//                       <span>Upload Video</span>
//                       <small>MP4, WebM up to 50MB</small>
//                       <input
//                         type="file"
//                         accept="video/*"
//                         onChange={(e) => {
//                           const file = e.target.files[0];
//                           if (file) {
//                             setEditVariant({
//                               ...editVariant,
//                               videoFile: file,
//                               videoPreview: URL.createObjectURL(file),
//                             });
//                           }
//                         }}
//                         style={{ display: 'none' }}
//                       />
//                     </label>
//                   </div>
//                   {editVariant.videoPreview && (
//                     <div className="video-preview">
//                       <video src={editVariant.videoPreview} controls />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => {
//                 setShowEditVariantModal(false);
//                 setEditingVariantIndex(null);
//                 setEditingVariantId(null);
//               }}
//             >
//               Cancel
//             </button>
//             <button 
//               className="btn btn-primary" 
//               onClick={editingVariantIndex !== null && editingVariantId ? handleUpdateVariant : handleSaveEditVariant}
//               disabled={!editVariant.color_name || editVariant.color_name.trim() === ''}
//             >
//               <FaPlus /> {editingVariantIndex !== null && editingVariantId ? 'Update' : 'Add'} Color
//             </button>
//           </Modal.Footer>
//         </Modal>

//         {/* ============================================= */}
//         {/* ADD PRODUCT MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showAddModal}
//           onHide={() => {
//             setShowAddModal(false);
//             resetProductForm();
//           }}
//           size="xl"
//           centered
//           className="add-product-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Add New Product</h2>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="modal-flex-container">
//               <div className="form-column">
//                 <div className="form-section">
//                   <h3>Product Details</h3>
//                   <div className="form-group">
//                     <label>
//                       Product Name <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       value={newProduct.name}
//                       onChange={(e) =>
//                         setNewProduct({ ...newProduct, name: e.target.value })
//                       }
//                       placeholder="e.g., Modern Wooden Chair"
//                     />
//                   </div>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label>
//                         Material <span className="required">*</span>
//                       </label>
//                       <select
//                         value={newProduct.material}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, material: e.target.value })
//                         }
//                       >
//                         {MATERIAL_CHOICES.map((choice) => (
//                           <option key={choice.value} value={choice.value}>
//                             {choice.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>
//                         Category <span className="required">*</span>
//                       </label>
//                       <select
//                         value={newProduct.category}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, category: e.target.value })
//                         }
//                       >
//                         {CATEGORY_CHOICES.map((choice) => (
//                           <option key={choice.value} value={choice.value}>
//                             {choice.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="form-group">
//                     <label>Description</label>
//                     <textarea
//                       value={newProduct.description}
//                       onChange={(e) =>
//                         setNewProduct({
//                           ...newProduct,
//                           description: e.target.value,
//                         })
//                       }
//                       placeholder="Describe your product..."
//                       rows="3"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>How It Works</label>
//                     <textarea
//                       value={newProduct.how_it_works}
//                       onChange={(e) =>
//                         setNewProduct({
//                           ...newProduct,
//                           how_it_works: e.target.value,
//                         })
//                       }
//                       placeholder="Explain how to use it..."
//                       rows="2"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Key Features</label>
//                     <textarea
//                       value={newProduct.key_features}
//                       onChange={(e) =>
//                         setNewProduct({
//                           ...newProduct,
//                           key_features: e.target.value,
//                         })
//                       }
//                       placeholder="List important features..."
//                       rows="2"
//                     />
//                   </div>
//                 </div>

//                 <div className="form-section">
//                   <h3>Size & Weight</h3>
//                   <div className="form-row three-col">
//                     <div className="form-group">
//                       <label>Length</label>
//                       <input
//                         type="number"
//                         value={newProduct.length}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, length: e.target.value })
//                         }
//                         placeholder="0.00"
//                         step="0.01"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>Width</label>
//                       <input
//                         type="number"
//                         value={newProduct.width}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, width: e.target.value })
//                         }
//                         placeholder="0.00"
//                         step="0.01"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>Height</label>
//                       <input
//                         type="number"
//                         value={newProduct.height}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, height: e.target.value })
//                         }
//                         placeholder="0.00"
//                         step="0.01"
//                       />
//                     </div>
//                   </div>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label>Unit</label>
//                       <select
//                         value={newProduct.dimension_unit}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, dimension_unit: e.target.value })
//                         }
//                       >
//                         {DIMENSION_UNIT_CHOICES.map((choice) => (
//                           <option key={choice.value} value={choice.value}>
//                             {choice.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Weight</label>
//                       <input
//                         type="number"
//                         value={newProduct.weight}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, weight: e.target.value })
//                         }
//                         placeholder="0.00"
//                         step="0.01"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>Weight Unit</label>
//                       <select
//                         value={newProduct.weight_unit}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, weight_unit: e.target.value })
//                         }
//                       >
//                         {WEIGHT_UNIT_CHOICES.map((choice) => (
//                           <option key={choice.value} value={choice.value}>
//                             {choice.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="form-section">
//                   <h3>Location & Availability</h3>
//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       value={newProduct.location}
//                       onChange={(e) =>
//                         setNewProduct({ ...newProduct, location: e.target.value })
//                       }
//                       placeholder="e.g., Nairobi, Kenya"
//                     />
//                   </div>
//                   <div className="form-group checkbox-group">
//                     <label>
//                       <input
//                         type="checkbox"
//                         checked={newProduct.is_available}
//                         onChange={(e) =>
//                           setNewProduct({ ...newProduct, is_available: e.target.checked })
//                         }
//                       />
//                       Available for purchase
//                     </label>
//                   </div>
//                 </div>
//               </div>

//               <div className="colors-column">
//                 <div className="form-section">
//                   <div className="colors-header">
//                     <h3>Colors / Options <span className="required">*</span></h3>
//                     <button
//                       type="button"
//                       className="add-color-btn"
//                       onClick={() => {
//                         setEditingColorIndex(null);
//                         resetColorForm();
//                         setShowAddColorModal(true);
//                       }}
//                     >
//                       <FaPlus /> Add Color
//                     </button>
//                   </div>
//                   <p className="color-required-note">
//                     Add at least one color option for your product
//                   </p>

//                   {newProduct.colorOptions.length === 0 ? (
//                     <div className="no-colors">
//                       <FaPalette />
//                       <p>No colors added yet. Click "Add Color" to get started.</p>
//                     </div>
//                   ) : (
//                     <div className="colors-list">
//                       {newProduct.colorOptions.map((color, index) => {
//                         const imageCount = ['front', 'back', 'left', 'right']
//                           .filter(type => color[`${type}Image`]).length;
//                         const hasVideo = !!color.videoFile;
//                         const isOnSale = color.sale_start_date && color.sale_end_date && 
//                           new Date() >= new Date(color.sale_start_date) && 
//                           new Date() <= new Date(color.sale_end_date);
                        
//                         return (
//                           <div key={index} className="color-item">
//                             <div className="color-info">
//                               <div className="color-display">
//                                 <span
//                                   className="color-dot"
//                                   style={{ backgroundColor: color.color_code || '#000000' }}
//                                 />
//                                 <span className="color-name">{color.color}</span>
//                                 {isOnSale && (
//                                   <span className="sale-tag">SALE</span>
//                                 )}
//                               </div>
//                               <div className="color-media">
//                                 {imageCount > 0 && (
//                                   <span className="media-badge">
//                                     <FaImage /> {imageCount}
//                                   </span>
//                                 )}
//                                 {hasVideo && (
//                                   <span className="media-badge video">
//                                     <FaVideo /> 1
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                             <div className="color-pricing">
//                               <span className="price-selling">{formatCurrency(color.selling_price)}</span>
//                               {color.original_price && color.selling_price && 
//                                color.selling_price < color.original_price && (
//                                 <span className="price-original">{formatCurrency(color.original_price)}</span>
//                               )}
//                               <span className="color-stock">Stock: {color.stock || 0}</span>
//                             </div>
//                             <div className="color-actions">
//                               <button
//                                 type="button"
//                                 className="edit-color-btn"
//                                 onClick={() => handleEditColorOption(index)}
//                               >
//                                 <FaEdit />
//                               </button>
//                               <button
//                                 type="button"
//                                 className="remove-color-btn"
//                                 onClick={() => handleRemoveColorOption(index)}
//                               >
//                                 <FaTrash />
//                               </button>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => {
//                 setShowAddModal(false);
//                 resetProductForm();
//               }}
//               disabled={actionLoading.add}
//             >
//               Cancel
//             </button>
//             <button
//               className="btn btn-primary"
//               onClick={handleAddProduct}
//               disabled={actionLoading.add || newProduct.colorOptions.length === 0}
//             >
//               {actionLoading.add ? (
//                 <>
//                   <FaSpinner className="spinner" /> Adding...
//                 </>
//               ) : (
//                 <>
//                   <FaPlus /> Add Product
//                 </>
//               )}
//             </button>
//           </Modal.Footer>
//         </Modal>

//         {/* ============================================= */}
//         {/* ADD COLOR MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showAddColorModal}
//           onHide={() => {
//             setShowAddColorModal(false);
//             setEditingColorIndex(null);
//             resetColorForm();
//           }}
//           size="lg"
//           centered
//           className="color-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>{editingColorIndex !== null ? 'Edit' : 'Add'} Color Option</h2>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="color-form-grid">
//               <div className="color-form-left">
//                 <div className="form-group">
//                   <label>
//                     Color Name <span className="required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     value={newColorOption.color}
//                     onChange={(e) =>
//                       setNewColorOption({ ...newColorOption, color: e.target.value })
//                     }
//                     placeholder="e.g., Brown, Black, White"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Color Code (HEX)</label>
//                   <div className="color-input-group">
//                     <input
//                       type="color"
//                       value={newColorOption.color_code}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, color_code: e.target.value })
//                       }
//                     />
//                     <input
//                       type="text"
//                       value={newColorOption.color_code}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, color_code: e.target.value })
//                       }
//                       placeholder="#RRGGBB"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>
//                       Original Price (KSh) <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       value={newColorOption.original_price}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, original_price: e.target.value })
//                       }
//                       placeholder="e.g., 8000"
//                       min="0"
//                       step="0.01"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>
//                       Selling Price (KSh) <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       value={newColorOption.selling_price}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, selling_price: e.target.value })
//                       }
//                       placeholder="e.g., 8000"
//                       min="0"
//                       step="0.01"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>
//                       Stock <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       value={newColorOption.stock}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, stock: e.target.value })
//                       }
//                       min="0"
//                     />
//                   </div>
//                   <div className="form-group checkbox-group">
//                     <label>
//                       <input
//                         type="checkbox"
//                         checked={newColorOption.is_available}
//                         onChange={(e) =>
//                           setNewColorOption({ ...newColorOption, is_available: e.target.checked })
//                         }
//                       />
//                       Available
//                     </label>
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Sale Start Date (Optional)</label>
//                     <input
//                       type="datetime-local"
//                       value={newColorOption.sale_start_date}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, sale_start_date: e.target.value })
//                       }
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Sale End Date (Optional)</label>
//                     <input
//                       type="datetime-local"
//                       value={newColorOption.sale_end_date}
//                       onChange={(e) =>
//                         setNewColorOption({ ...newColorOption, sale_end_date: e.target.value })
//                       }
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="color-form-right">
//                 <div className="form-group">
//                   <label>Photos of this color</label>
//                   <div className="image-upload-grid">
//                     {['front', 'back', 'left', 'right'].map((type) => (
//                       <div key={type} className="image-upload-item">
//                         <label className="image-type-label">
//                           {IMAGE_LABELS[type]}
//                         </label>
//                         <div className="image-upload-box">
//                           {newColorOption[`${type}Preview`] ? (
//                             <div className="image-preview">
//                               <img src={newColorOption[`${type}Preview`]} alt={type} />
//                               <button
//                                 type="button"
//                                 className="remove-image"
//                                 onClick={() => removeColorImage(type)}
//                               >
//                                 <FaTimes />
//                               </button>
//                             </div>
//                           ) : (
//                             <label className="upload-box-label">
//                               <FaUpload />
//                               <span>Upload</span>
//                               <input
//                                 type="file"
//                                 accept="image/*"
//                                 onChange={(e) => handleColorImageUpload(type, e)}
//                                 style={{ display: 'none' }}
//                               />
//                             </label>
//                           )}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="form-group">
//                   <label>Video of this color (Optional)</label>
//                   <div className="video-upload-box">
//                     {newColorOption.videoPreview ? (
//                       <div className="video-preview">
//                         <video src={newColorOption.videoPreview} controls />
//                         <button
//                           type="button"
//                           className="remove-video"
//                           onClick={removeColorVideo}
//                         >
//                           <FaTimes />
//                         </button>
//                       </div>
//                     ) : (
//                       <label className="upload-box-label video">
//                         <FaUpload />
//                         <span>Upload Video</span>
//                         <small>MP4, WebM up to 50MB</small>
//                         <input
//                           type="file"
//                           accept="video/*"
//                           onChange={handleColorVideoUpload}
//                           style={{ display: 'none' }}
//                         />
//                       </label>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => {
//                 setShowAddColorModal(false);
//                 setEditingColorIndex(null);
//                 resetColorForm();
//               }}
//             >
//               Cancel
//             </button>
//             <button 
//               className="btn btn-primary" 
//               onClick={handleAddColorOption}
//               disabled={!newColorOption.color || newColorOption.color.trim() === ''}
//             >
//               <FaPlus /> {editingColorIndex !== null ? 'Update' : 'Add'} Color
//             </button>
//           </Modal.Footer>
//         </Modal>

//         {/* ============================================= */}
//         {/* DELETE CONFIRMATION MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showDeleteModal}
//           onHide={() => setShowDeleteModal(false)}
//           centered
//           className="delete-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Delete Product</h2>
//           </Modal.Header>
//           <Modal.Body>
//             {productToDelete && (
//               <p>
//                 Are you sure you want to delete{' '}
//                 <strong>"{productToDelete.name}"</strong>? This action cannot be
//                 undone.
//               </p>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => setShowDeleteModal(false)}
//               disabled={actionLoading.delete}
//             >
//               Cancel
//             </button>
//             <button
//               className="btn btn-danger"
//               onClick={handleDeleteProduct}
//               disabled={actionLoading.delete}
//             >
//               {actionLoading.delete ? (
//                 <>
//                   <FaSpinner className="spinner" /> Deleting...
//                 </>
//               ) : (
//                 'Delete Product'
//               )}
//             </button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanReadyProducts, 'artisan');



// src/pages/artisan/readyproducts/ArtisanReadyProducts.jsx
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaEyeSlash,
  FaShoppingBag,
  FaDollarSign,
  FaSearch,
  FaThLarge,
  FaList,
  FaBoxes,
  FaImage,
  FaSpinner,
  FaCalendarAlt,
  FaRulerCombined,
  FaWeight,
  FaPalette,
  FaVideo,
  FaTimes,
  FaUpload,
  FaTimesCircle,
  FaCheckCircle,
  FaInfoCircle,
  FaTag,
  FaStore,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import './readyproducts.scss';
import Sidebar from '../../../../components/layout/Sidebar';
import withAuth from '../../../auth/WithAuth';
import { serverUrlAuth } from '../../../../serverUrl';

const IMAGE_LABELS = {
  front: 'Front View',
  back: 'Back View',
  left: 'Left Side',
  right: 'Right Side',
};

const ArtisanReadyProducts = () => {
  const [viewMode, setViewMode] = useState('grid');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productToDelete, setProductToDelete] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({
    add: false,
    edit: false,
    delete: false,
    toggleStatus: false,
  });
  const [shopStats, setShopStats] = useState({
    totalProducts: 0,
    activeProducts: 0,
    totalSales: 0,
    totalRevenue: 0,
    lowStock: 0,
    outOfStock: 0,
  });

  const MATERIAL_CHOICES = [
    { value: 'wood', label: 'Wood' },
    { value: 'metal', label: 'Metal' },
    { value: 'plastic', label: 'Plastic' },
    { value: 'glass', label: 'Glass' },
    { value: 'fabric', label: 'Fabric' },
    { value: 'leather', label: 'Leather' },
    { value: 'ceramic', label: 'Ceramic' },
    { value: 'concrete', label: 'Concrete' },
    { value: 'rattan', label: 'Rattan' },
    { value: 'bamboo', label: 'Bamboo' },
    { value: 'stone', label: 'Stone' },
    { value: 'mixed', label: 'Mixed Materials' },
    { value: 'other', label: 'Other' },
  ];

  const CATEGORY_CHOICES = [
    { value: 'furniture', label: 'Furniture' },
    { value: 'decor', label: 'Home Decor' },
    { value: 'art', label: 'Art & Crafts' },
    { value: 'clothing', label: 'Clothing' },
    { value: 'other', label: 'Other' },
  ];

  const DIMENSION_UNIT_CHOICES = [
    { value: 'cm', label: 'Centimeters (cm)' },
    { value: 'm', label: 'Meters (m)' },
    { value: 'in', label: 'Inches (in)' },
  ];

  const WEIGHT_UNIT_CHOICES = [
    { value: 'kg', label: 'Kilograms (kg)' },
    { value: 'g', label: 'Grams (g)' },
  ];

  const [newProduct, setNewProduct] = useState({
    name: '',
    material: 'wood',
    category: 'furniture',
    description: '',
    how_it_works: '',
    key_features: '',
    length: '',
    width: '',
    height: '',
    dimension_unit: 'cm',
    weight: '',
    weight_unit: 'kg',
    location: '',
    is_available: true,
    colorOptions: [],
  });

  const [editProduct, setEditProduct] = useState({
    name: '',
    material: '',
    category: '',
    description: '',
    how_it_works: '',
    key_features: '',
    length: '',
    width: '',
    height: '',
    dimension_unit: 'cm',
    weight: '',
    weight_unit: 'kg',
    location: '',
    is_available: true,
  });

  // Edit variant state
  const [editVariants, setEditVariants] = useState([]);
  const [showEditVariantModal, setShowEditVariantModal] = useState(false);
  const [editingVariantId, setEditingVariantId] = useState(null);
  const [editingVariantIndex, setEditingVariantIndex] = useState(null);

  const [editVariant, setEditVariant] = useState({
    color_name: '',
    color_code: '#000000',
    original_price: '',
    selling_price: '',
    sale_start_date: '',
    sale_end_date: '',
    stock: '1',
    is_available: true,
  });

  const [newColorOption, setNewColorOption] = useState({
    color: '',
    color_code: '#000000',
    original_price: '',
    selling_price: '',
    sale_start_date: '',
    sale_end_date: '',
    stock: '1',
    is_available: true,
    frontImage: null,
    backImage: null,
    leftImage: null,
    rightImage: null,
    videoFile: null,
    frontPreview: null,
    backPreview: null,
    leftPreview: null,
    rightPreview: null,
    videoPreview: null,
  });

  const [showAddColorModal, setShowAddColorModal] = useState(false);
  const [editingColorIndex, setEditingColorIndex] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      calculateShopStats();
    }
  }, [products]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('projects/ready-made-products/');
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  const calculateShopStats = () => {
    let totalRevenue = 0;
    products.forEach((product) => {
      if (product.variants) {
        product.variants.forEach((variant) => {
          const price = variant.is_on_sale
            ? parseFloat(variant.selling_price || 0)
            : parseFloat(variant.original_price || 0);
          totalRevenue += price * (variant.sold_count || 0);
        });
      }
    });

    const stats = {
      totalProducts: products.length,
      activeProducts: products.filter((p) => p.is_available).length,
      totalSales: products.reduce((sum, p) => {
        let variantSum = 0;
        if (p.variants) {
          p.variants.forEach((v) => (variantSum += v.sold_count || 0));
        }
        return sum + variantSum;
      }, 0),
      totalRevenue: totalRevenue,
      lowStock: products.filter((p) => {
        let totalStock = 0;
        if (p.variants) {
          p.variants.forEach((v) => (totalStock += v.stock || 0));
        }
        return totalStock > 0 && totalStock <= 5;
      }).length,
      outOfStock: products.filter((p) => {
        let totalStock = 0;
        if (p.variants) {
          p.variants.forEach((v) => (totalStock += v.stock || 0));
        }
        return totalStock === 0;
      }).length,
    };
    setShopStats(stats);
  };

  const filteredProducts = products.filter((product) => {
    const matchesSearch =
      product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.code?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      filterStatus === 'all'
        ? true
        : filterStatus === 'active'
          ? product.is_available
          : filterStatus === 'inactive'
            ? !product.is_available
            : true;

    return matchesSearch && matchesStatus;
  });

  const formatCurrency = (amount) => {
    if (!amount || amount === '0.00' || amount === 0) return 'KSh 0';
    return `KSh ${parseFloat(amount).toLocaleString()}`;
  };

  const getVariantDisplayPrice = (variant) => {
    if (!variant) return 0;
    if (variant.is_on_sale) {
      return parseFloat(variant.selling_price || 0);
    }
    return parseFloat(variant.original_price || 0);
  };

  const getPriceRange = (product) => {
    if (!product.variants || product.variants.length === 0) return 'KSh 0';

    const prices = product.variants.map((v) => {
      return v.is_on_sale
        ? parseFloat(v.selling_price || 0)
        : parseFloat(v.original_price || 0);
    });

    const min = Math.min(...prices);
    const max = Math.max(...prices);
    if (min === max) return formatCurrency(min);
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  };

  const isProductOnSale = (product) => {
    if (!product.variants || product.variants.length === 0) return false;
    return product.variants.some((v) => v.is_on_sale === true);
  };

  const getProductDiscount = (product) => {
    if (!product.variants || product.variants.length === 0) return 0;
    const discounts = product.variants.map((v) => {
      if (!v.is_on_sale) return 0;
      const original = parseFloat(v.original_price || 0);
      const selling = parseFloat(v.selling_price || 0);
      if (original === 0 || selling === 0) return 0;
      return Math.round(((original - selling) / original) * 100);
    });
    return Math.max(...discounts);
  };

  const handleColorImageUpload = (type, e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setNewColorOption({
        ...newColorOption,
        [`${type}Image`]: file,
        [`${type}Preview`]: preview,
      });
    }
  };

  const removeColorImage = (type) => {
    if (newColorOption[`${type}Preview`]) {
      URL.revokeObjectURL(newColorOption[`${type}Preview`]);
    }
    setNewColorOption({
      ...newColorOption,
      [`${type}Image`]: null,
      [`${type}Preview`]: null,
    });
  };

  const handleColorVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setNewColorOption({
        ...newColorOption,
        videoFile: file,
        videoPreview: preview,
      });
    }
  };

  const removeColorVideo = () => {
    if (newColorOption.videoPreview) {
      URL.revokeObjectURL(newColorOption.videoPreview);
    }
    setNewColorOption({
      ...newColorOption,
      videoFile: null,
      videoPreview: null,
    });
  };

  const handleAddColorOption = () => {
    if (!newColorOption.color || newColorOption.color.trim() === '') {
      toast.error('Please enter a color name');
      return;
    }

    if (
      !newColorOption.original_price ||
      parseFloat(newColorOption.original_price) <= 0
    ) {
      toast.error('Please enter a valid original price for this color');
      return;
    }

    if (
      !newColorOption.selling_price ||
      parseFloat(newColorOption.selling_price) <= 0
    ) {
      toast.error('Please enter a valid selling price for this color');
      return;
    }

    if (
      parseFloat(newColorOption.selling_price) >
      parseFloat(newColorOption.original_price)
    ) {
      toast.error('Selling price cannot be more than original price');
      return;
    }

    if (newColorOption.sale_start_date && newColorOption.sale_end_date) {
      if (
        new Date(newColorOption.sale_end_date) <=
        new Date(newColorOption.sale_start_date)
      ) {
        toast.error('Sale end date must be after sale start date');
        return;
      }
    }

    const colorData = {
      color: newColorOption.color.trim(),
      color_code: newColorOption.color_code || '#000000',
      original_price: parseFloat(newColorOption.original_price),
      selling_price: parseFloat(newColorOption.selling_price),
      sale_start_date: newColorOption.sale_start_date || null,
      sale_end_date: newColorOption.sale_end_date || null,
      stock: parseInt(newColorOption.stock) || 0,
      is_available: newColorOption.is_available !== false,
      frontImage: newColorOption.frontImage,
      backImage: newColorOption.backImage,
      leftImage: newColorOption.leftImage,
      rightImage: newColorOption.rightImage,
      videoFile: newColorOption.videoFile,
      frontPreview: newColorOption.frontPreview,
      backPreview: newColorOption.backPreview,
      leftPreview: newColorOption.leftPreview,
      rightPreview: newColorOption.rightPreview,
      videoPreview: newColorOption.videoPreview,
    };

    if (editingColorIndex !== null) {
      const updatedColors = [...newProduct.colorOptions];
      updatedColors[editingColorIndex] = colorData;
      setNewProduct({ ...newProduct, colorOptions: updatedColors });
      setEditingColorIndex(null);
    } else {
      setNewProduct({
        ...newProduct,
        colorOptions: [...newProduct.colorOptions, colorData],
      });
    }

    resetColorForm();
    setShowAddColorModal(false);
    toast.success(
      editingColorIndex !== null ? 'Color updated' : 'Color added',
    );
  };

  const resetColorForm = () => {
    ['front', 'back', 'left', 'right'].forEach((type) => {
      if (newColorOption[`${type}Preview`]) {
        URL.revokeObjectURL(newColorOption[`${type}Preview`]);
      }
    });
    if (newColorOption.videoPreview) {
      URL.revokeObjectURL(newColorOption.videoPreview);
    }

    setNewColorOption({
      color: '',
      color_code: '#000000',
      original_price: '',
      selling_price: '',
      sale_start_date: '',
      sale_end_date: '',
      stock: '1',
      is_available: true,
      frontImage: null,
      backImage: null,
      leftImage: null,
      rightImage: null,
      videoFile: null,
      frontPreview: null,
      backPreview: null,
      leftPreview: null,
      rightPreview: null,
      videoPreview: null,
    });
  };

  const handleEditColorOption = (index) => {
    const color = newProduct.colorOptions[index];
    setNewColorOption({
      color: color.color || '',
      color_code: color.color_code || '#000000',
      original_price: color.original_price?.toString() || '',
      selling_price: color.selling_price?.toString() || '',
      sale_start_date: color.sale_start_date || '',
      sale_end_date: color.sale_end_date || '',
      stock: color.stock?.toString() || '1',
      is_available: color.is_available !== false,
      frontImage: color.frontImage || null,
      backImage: color.backImage || null,
      leftImage: color.leftImage || null,
      rightImage: color.rightImage || null,
      videoFile: color.videoFile || null,
      frontPreview: color.frontPreview || null,
      backPreview: color.backPreview || null,
      leftPreview: color.leftPreview || null,
      rightPreview: color.rightPreview || null,
      videoPreview: color.videoPreview || null,
    });
    setEditingColorIndex(index);
    setShowAddColorModal(true);
  };

  const handleRemoveColorOption = (index) => {
    const color = newProduct.colorOptions[index];
    ['front', 'back', 'left', 'right'].forEach((type) => {
      if (color[`${type}Preview`]) {
        URL.revokeObjectURL(color[`${type}Preview`]);
      }
    });
    if (color.videoPreview) {
      URL.revokeObjectURL(color.videoPreview);
    }

    const updatedColors = newProduct.colorOptions.filter((_, i) => i !== index);
    setNewProduct({ ...newProduct, colorOptions: updatedColors });
  };

  // =============================================
  // EDIT PRODUCT HANDLERS
  // =============================================
  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setEditProduct({
      name: product.name || '',
      material: product.material || '',
      category: product.category || '',
      description: product.description || '',
      how_it_works: product.how_it_works || '',
      key_features: product.key_features || '',
      length: product.length?.toString() || '',
      width: product.width?.toString() || '',
      height: product.height?.toString() || '',
      dimension_unit: product.dimension_unit || 'cm',
      weight: product.weight?.toString() || '',
      weight_unit: product.weight_unit || 'kg',
      location: product.location || '',
      is_available: product.is_available !== false,
    });

    if (product.variants && product.variants.length > 0) {
      setEditVariants(
        product.variants.map((v) => ({
          ...v,
          _original: { ...v },
        })),
      );
    } else {
      setEditVariants([]);
    }

    setShowEditModal(true);
  };

  const handleEditVariantClick = (index) => {
    const variant = editVariants[index];
    setEditingVariantIndex(index);
    setEditingVariantId(variant.id);
    setEditVariant({
      color_name: variant.color_name || '',
      color_code: variant.color_code || '#000000',
      original_price: variant.original_price?.toString() || '',
      selling_price: variant.selling_price?.toString() || '',
      sale_start_date: variant.sale_start_date || '',
      sale_end_date: variant.sale_end_date || '',
      stock: variant.stock?.toString() || '1',
      is_available: variant.is_available !== false,
    });
    setShowEditVariantModal(true);
  };

  const handleUpdateVariant = () => {
    if (!editVariant.color_name || editVariant.color_name.trim() === '') {
      toast.error('Please enter a color name');
      return;
    }

    if (
      !editVariant.original_price ||
      parseFloat(editVariant.original_price) <= 0
    ) {
      toast.error('Please enter a valid original price');
      return;
    }

    if (
      !editVariant.selling_price ||
      parseFloat(editVariant.selling_price) <= 0
    ) {
      toast.error('Please enter a valid selling price');
      return;
    }

    if (
      parseFloat(editVariant.selling_price) >
      parseFloat(editVariant.original_price)
    ) {
      toast.error('Selling price cannot be more than original price');
      return;
    }

    if (editVariant.sale_start_date && editVariant.sale_end_date) {
      if (
        new Date(editVariant.sale_end_date) <=
        new Date(editVariant.sale_start_date)
      ) {
        toast.error('Sale end date must be after sale start date');
        return;
      }
    }

    const updatedVariants = [...editVariants];
    updatedVariants[editingVariantIndex] = {
      ...updatedVariants[editingVariantIndex],
      color_name: editVariant.color_name.trim(),
      color_code: editVariant.color_code || '#000000',
      original_price: parseFloat(editVariant.original_price),
      selling_price: parseFloat(editVariant.selling_price),
      sale_start_date: editVariant.sale_start_date || null,
      sale_end_date: editVariant.sale_end_date || null,
      stock: parseInt(editVariant.stock) || 0,
      is_available: editVariant.is_available !== false,
    };

    setEditVariants(updatedVariants);
    setShowEditVariantModal(false);
    toast.success('Variant updated successfully');
  };

  const handleRemoveEditVariant = (index) => {
    if (editVariants.length <= 1) {
      toast.error('Product must have at least one color option');
      return;
    }
    const updatedVariants = editVariants.filter((_, i) => i !== index);
    setEditVariants(updatedVariants);
    toast.success('Variant removed');
  };

  const handleAddEditVariant = () => {
    setEditingVariantIndex(null);
    setEditingVariantId(null);
    setEditVariant({
      color_name: '',
      color_code: '#000000',
      original_price: '',
      selling_price: '',
      sale_start_date: '',
      sale_end_date: '',
      stock: '1',
      is_available: true,
    });
    setShowEditVariantModal(true);
  };

  const handleSaveEditVariant = () => {
    if (!editVariant.color_name || editVariant.color_name.trim() === '') {
      toast.error('Please enter a color name');
      return;
    }

    if (
      !editVariant.original_price ||
      parseFloat(editVariant.original_price) <= 0
    ) {
      toast.error('Please enter a valid original price');
      return;
    }

    if (
      !editVariant.selling_price ||
      parseFloat(editVariant.selling_price) <= 0
    ) {
      toast.error('Please enter a valid selling price');
      return;
    }

    if (
      parseFloat(editVariant.selling_price) >
      parseFloat(editVariant.original_price)
    ) {
      toast.error('Selling price cannot be more than original price');
      return;
    }

    if (editVariant.sale_start_date && editVariant.sale_end_date) {
      if (
        new Date(editVariant.sale_end_date) <=
        new Date(editVariant.sale_start_date)
      ) {
        toast.error('Sale end date must be after sale start date');
        return;
      }
    }

    const newVariant = {
      id: null,
      color_name: editVariant.color_name.trim(),
      color_code: editVariant.color_code || '#000000',
      original_price: parseFloat(editVariant.original_price),
      selling_price: parseFloat(editVariant.selling_price),
      sale_start_date: editVariant.sale_start_date || null,
      sale_end_date: editVariant.sale_end_date || null,
      stock: parseInt(editVariant.stock) || 0,
      is_available: editVariant.is_available !== false,
      images: [],
      video: null,
    };

    setEditVariants([...editVariants, newVariant]);
    setShowEditVariantModal(false);
    toast.success('New variant added');
  };

  const handleUpdateProduct = async () => {
    if (!selectedProduct) return;

    try {
      setActionLoading((prev) => ({ ...prev, edit: true }));

      const updateData = {
        name: editProduct.name,
        material: editProduct.material,
        category: editProduct.category,
        description: editProduct.description,
        how_it_works: editProduct.how_it_works,
        key_features: editProduct.key_features,
        length: editProduct.length || '0',
        width: editProduct.width || '0',
        height: editProduct.height || '0',
        dimension_unit: editProduct.dimension_unit,
        weight: editProduct.weight || '0',
        weight_unit: editProduct.weight_unit,
        location: editProduct.location,
        is_available: editProduct.is_available,
      };

      await serverUrlAuth.patch(
        `projects/ready-made-products/${selectedProduct.id}/`,
        updateData,
      );

      const originalVariants = selectedProduct.variants || [];

      for (const variant of editVariants) {
        if (variant.id) {
          const variantData = {
            color_name: variant.color_name,
            color_code: variant.color_code,
            original_price: variant.original_price,
            selling_price: variant.selling_price,
            sale_start_date: variant.sale_start_date,
            sale_end_date: variant.sale_end_date,
            stock: variant.stock,
            is_available: variant.is_available,
          };

          try {
            await serverUrlAuth.patch(
              `projects/product-variants/${variant.id}/`,
              variantData,
            );
          } catch (err) {
            console.error(`Error updating variant ${variant.id}:`, err);
          }
        } else {
          const formData = new FormData();
          formData.append('product', selectedProduct.id);
          formData.append('color_name', variant.color_name);
          formData.append('color_code', variant.color_code || '#000000');
          formData.append('original_price', variant.original_price);
          formData.append('selling_price', variant.selling_price);
          formData.append('stock', variant.stock);
          formData.append(
            'is_available',
            variant.is_available ? 'true' : 'false',
          );
          if (variant.sale_start_date) {
            formData.append('sale_start_date', variant.sale_start_date);
          }
          if (variant.sale_end_date) {
            formData.append('sale_end_date', variant.sale_end_date);
          }

          try {
            await serverUrlAuth.post('projects/product-variants/', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
          } catch (err) {
            console.error('Error creating variant:', err);
          }
        }
      }

      const originalIds = originalVariants.map((v) => v.id);
      const currentIds = editVariants.filter((v) => v.id).map((v) => v.id);
      const deletedIds = originalIds.filter((id) => !currentIds.includes(id));

      for (const id of deletedIds) {
        try {
          await serverUrlAuth.delete(`projects/product-variants/${id}/`);
        } catch (err) {
          console.error(`Error deleting variant ${id}:`, err);
        }
      }

      await fetchProducts();
      setShowEditModal(false);
      toast.success('Product updated successfully');
    } catch (error) {
      console.error('Error updating product:', error);
      toast.error(error.response?.data?.message || 'Failed to update product');
    } finally {
      setActionLoading((prev) => ({ ...prev, edit: false }));
    }
  };

  const handleViewClick = (product) => {
    setSelectedProduct(product);
    setShowViewModal(true);
  };

  const handleDeleteClick = (product) => {
    setProductToDelete(product);
    setShowDeleteModal(true);
  };

  const handleDeleteProduct = async () => {
    if (!productToDelete) return;

    try {
      setActionLoading((prev) => ({ ...prev, delete: true }));
      await serverUrlAuth.delete(
        `projects/ready-made-products/${productToDelete.id}/`,
      );
      setProducts(products.filter((p) => p.id !== productToDelete.id));
      setShowDeleteModal(false);
      setProductToDelete(null);
      toast.success('Product deleted successfully');
    } catch (error) {
      console.error('Error deleting product:', error);
      toast.error('Failed to delete product');
    } finally {
      setActionLoading((prev) => ({ ...prev, delete: false }));
    }
  };

  const handleToggleStatus = async (productId) => {
    const product = products.find((p) => p.id === productId);
    try {
      setActionLoading((prev) => ({ ...prev, toggleStatus: true }));
      const response = await serverUrlAuth.patch(
        `projects/ready-made-products/${productId}/`,
        { is_available: !product.is_available },
      );
      setProducts(
        products.map((p) =>
          p.id === productId
            ? { ...p, is_available: response.data.is_available }
            : p,
        ),
      );
      toast.success(
        `Product ${response.data.is_available ? 'activated' : 'deactivated'}`,
      );
    } catch (error) {
      console.error('Error toggling product status:', error);
      toast.error('Failed to update product status');
    } finally {
      setActionLoading((prev) => ({ ...prev, toggleStatus: false }));
    }
  };

  const handleAddProduct = async () => {
    if (!newProduct.name || newProduct.name.trim() === '') {
      toast.error('Please enter a product name');
      return;
    }

    if (newProduct.colorOptions.length === 0) {
      toast.error('Please add at least one color option');
      return;
    }

    for (const color of newProduct.colorOptions) {
      if (!color.color || color.color.trim() === '') {
        toast.error('All colors must have a name');
        return;
      }
      if (!color.original_price || parseFloat(color.original_price) <= 0) {
        toast.error(`Color "${color.color}" needs an original price`);
        return;
      }
      if (!color.selling_price || parseFloat(color.selling_price) <= 0) {
        toast.error(`Color "${color.color}" needs a selling price`);
        return;
      }
      if (
        parseFloat(color.selling_price) > parseFloat(color.original_price)
      ) {
        toast.error(
          `Color "${color.color}" selling price cannot be more than original price`,
        );
        return;
      }
      if (color.sale_start_date && color.sale_end_date) {
        if (
          new Date(color.sale_end_date) <= new Date(color.sale_start_date)
        ) {
          toast.error(
            `Color "${color.color}" sale end date must be after start date`,
          );
          return;
        }
      }
    }

    const formData = new FormData();

    formData.append('name', newProduct.name.trim());
    formData.append('material', newProduct.material);
    formData.append('category', newProduct.category);
    formData.append('description', newProduct.description || '');
    formData.append('how_it_works', newProduct.how_it_works || '');
    formData.append('key_features', newProduct.key_features || '');
    formData.append('length', newProduct.length || '0');
    formData.append('width', newProduct.width || '0');
    formData.append('height', newProduct.height || '0');
    formData.append('dimension_unit', newProduct.dimension_unit);
    formData.append('weight', newProduct.weight || '0');
    formData.append('weight_unit', newProduct.weight_unit);
    formData.append('location', newProduct.location || '');
    formData.append('is_available', newProduct.is_available ? 'true' : 'false');

    newProduct.colorOptions.forEach((color, index) => {
      formData.append(`variants[${index}][color_name]`, color.color.trim());
      formData.append(
        `variants[${index}][color_code]`,
        color.color_code || '#000000',
      );
      formData.append(
        `variants[${index}][original_price]`,
        color.original_price,
      );
      formData.append(
        `variants[${index}][selling_price]`,
        color.selling_price,
      );
      formData.append(`variants[${index}][stock]`, parseInt(color.stock) || 0);
      formData.append(
        `variants[${index}][is_available]`,
        color.is_available !== false ? 'true' : 'false',
      );

      if (color.sale_start_date) {
        formData.append(
          `variants[${index}][sale_start_date]`,
          color.sale_start_date,
        );
      }
      if (color.sale_end_date) {
        formData.append(
          `variants[${index}][sale_end_date]`,
          color.sale_end_date,
        );
      }

      ['front', 'back', 'left', 'right'].forEach((type) => {
        if (color[`${type}Image`]) {
          formData.append(
            `variants[${index}][${type}]`,
            color[`${type}Image`],
          );
        }
      });

      if (color.videoFile) {
        formData.append(`variants[${index}][video]`, color.videoFile);
      }
    });

    try {
      setActionLoading((prev) => ({ ...prev, add: true }));
      const response = await serverUrlAuth.post(
        'projects/ready-made-products/',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      setProducts([response.data, ...products]);
      setShowAddModal(false);
      resetProductForm();
      toast.success('Product added successfully');
    } catch (error) {
      console.error('Error adding product:', error);
      let errorMsg = 'Failed to add product';
      if (error.response?.data) {
        if (typeof error.response.data === 'object') {
          const errors = Object.entries(error.response.data)
            .map(
              ([key, value]) =>
                `${key}: ${Array.isArray(value) ? value.join(', ') : value}`,
            )
            .join('\n');
          errorMsg = errors || JSON.stringify(error.response.data);
        } else {
          errorMsg = error.response.data;
        }
      }
      toast.error(errorMsg);
    } finally {
      setActionLoading((prev) => ({ ...prev, add: false }));
    }
  };

  const resetProductForm = () => {
    newProduct.colorOptions.forEach((color) => {
      ['front', 'back', 'left', 'right'].forEach((type) => {
        if (color[`${type}Preview`]) {
          URL.revokeObjectURL(color[`${type}Preview`]);
        }
      });
      if (color.videoPreview) {
        URL.revokeObjectURL(color.videoPreview);
      }
    });

    setNewProduct({
      name: '',
      material: 'wood',
      category: 'furniture',
      description: '',
      how_it_works: '',
      key_features: '',
      length: '',
      width: '',
      height: '',
      dimension_unit: 'cm',
      weight: '',
      weight_unit: 'kg',
      location: '',
      is_available: true,
      colorOptions: [],
    });

    resetColorForm();
    setEditingColorIndex(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getMaterialLabel = (value) => {
    const choice = MATERIAL_CHOICES.find((c) => c.value === value);
    return choice ? choice.label : value;
  };

  const getCategoryLabel = (value) => {
    const choice = CATEGORY_CHOICES.find((c) => c.value === value);
    return choice ? choice.label : value;
  };

  const getTotalStock = (product) => {
    if (!product.variants) return 0;
    return product.variants.reduce((sum, v) => sum + (v.stock || 0), 0);
  };

  const getTotalSold = (product) => {
    if (!product.variants) return 0;
    return product.variants.reduce((sum, v) => sum + (v.sold_count || 0), 0);
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="modern-dashboard artisan-ready-products">
          <div className="loading-spinner">
            <FaSpinner className="spinner" />
            <p>Loading products...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard artisan-ready-products">
        <div className="products-container">
         

          {/* Header */}
          <div className="products-header">
            <div className="header-left">
              <h1>My Products</h1>
              <div className="shop-status">
                <span className="products-count">
                  <span>{products.length}</span> products
                </span>
              </div>
            </div>
            <div className="header-actions">
              <button
                className="add-product-btn"
                onClick={() => setShowAddModal(true)}
              >
                <FaPlus /> Add New Product
              </button>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="shop-stats">
            <div className="stat-card">
              <div className="stat-icon">
                <FaBoxes />
              </div>
              <div className="stat-info">
                <div className="stat-value">{shopStats.totalProducts}</div>
                <div className="stat-label">Total Products</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FaEye />
              </div>
              <div className="stat-info">
                <div className="stat-value">{shopStats.activeProducts}</div>
                <div className="stat-label">In Stock</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FaShoppingBag />
              </div>
              <div className="stat-info">
                <div className="stat-value">{shopStats.totalSales}</div>
                <div className="stat-label">Items Sold</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FaDollarSign />
              </div>
              <div className="stat-info">
                <div className="stat-value">
                  {formatCurrency(shopStats.totalRevenue)}
                </div>
                <div className="stat-label">Total Sales</div>
              </div>
            </div>
          </div>

          {/* Search and Filters */}
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch />
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="filter-actions">
              <select
                className="filter-select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All</option>
                <option value="active">Available</option>
                <option value="inactive">Unavailable</option>
              </select>
              <div className="view-toggle">
                <button
                  className={viewMode === 'grid' ? 'active' : ''}
                  onClick={() => setViewMode('grid')}
                >
                  <FaThLarge />
                </button>
                <button
                  className={viewMode === 'list' ? 'active' : ''}
                  onClick={() => setViewMode('list')}
                >
                  <FaList />
                </button>
              </div>
            </div>
          </div>

          {/* Products Display */}
          {filteredProducts.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                <FaBoxes />
              </div>
              <h2>No products yet</h2>
              <p>Start selling by adding your first product</p>
              <button
                className="add-first-btn"
                onClick={() => setShowAddModal(true)}
              >
                <FaPlus /> Add Your First Product
              </button>
            </div>
          ) : (
            <div
              className={`products-grid ${
                viewMode === 'list' ? 'list-view' : ''
              }`}
            >
              {filteredProducts.map((product) => {
                const totalStock = getTotalStock(product);
                const totalSold = getTotalSold(product);
                const priceRange = getPriceRange(product);
                const isOnSale = isProductOnSale(product);
                const discountPercent = getProductDiscount(product);

                return (
                  <div key={product.id} className="product-card">
                    <div className="product-image">
                      {product.variants &&
                      product.variants.length > 0 &&
                      product.variants[0].images &&
                      product.variants[0].images.length > 0 ? (
                        <img
                          src={product.variants[0].images[0].image_url}
                          alt={product.name}
                        />
                      ) : (
                        <div className="image-placeholder">
                          <FaImage />
                        </div>
                      )}
                      {isOnSale && discountPercent > 0 && (
                        <div className="sale-badge">-{discountPercent}%</div>
                      )}
                      {totalStock === 0 && (
                        <div className="stock-overlay">Out of Stock</div>
                      )}
                      {totalStock > 0 && totalStock <= 2 && (
                        <div className="stock-overlay low-stock">
                          Low Stock: {totalStock} left
                        </div>
                      )}
                    </div>
                    <div className="product-info">
                      <div className="product-code">{product.code}</div>
                      <h3 className="product-name">{product.name}</h3>
                      <div className="product-meta">
                        <span className="material-badge">
                          {getMaterialLabel(product.material)}
                        </span>
                        <span className="category-badge">
                          {getCategoryLabel(product.category)}
                        </span>
                      </div>
                      <div className="product-pricing">
                        <span className="current-price">{priceRange}</span>
                        {isOnSale && (
                          <span className="sale-badge-text">ON SALE</span>
                        )}
                      </div>
                      <div className="product-stats">
                        <span>
                          <FaBoxes /> Stock: {totalStock}
                        </span>
                        <span>
                          <FaShoppingBag /> Sold: {totalSold}
                        </span>
                        {product.variants && (
                          <span>
                            <FaPalette /> {product.variants.length} colors
                          </span>
                        )}
                      </div>
                      <div className="product-dimensions">
                        <FaRulerCombined /> {product.dimensions}
                      </div>
                      <p className="product-description">
                        {product.description?.substring(0, 100)}
                        {product.description?.length > 100 ? '...' : ''}
                      </p>
                    </div>
                    <div className="product-actions">
                      <button
                        className="view-btn"
                        onClick={() => handleViewClick(product)}
                      >
                        <FaEye /> View
                      </button>
                      <button
                        className="edit-btn"
                        onClick={() => handleEditClick(product)}
                        disabled={actionLoading.edit}
                      >
                        <FaEdit /> Edit
                      </button>
                      <button
                        className="edit-btn delete-btn"
                        onClick={() => handleDeleteClick(product)}
                        disabled={actionLoading.delete}
                      >
                        {actionLoading.delete ? (
                          <FaSpinner className="spinner" />
                        ) : (
                          <FaTrash />
                        )}{' '}
                        Delete
                      </button>
                      <button
                        className={`toggle-btn ${
                          product.is_available ? '' : 'inactive'
                        }`}
                        onClick={() => handleToggleStatus(product.id)}
                        disabled={actionLoading.toggleStatus}
                      >
                        {product.is_available ? 'Out of Stock' : 'In Stock'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* ============================================= */}
        {/* VIEW PRODUCT MODAL */}
        {/* ============================================= */}
        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          size="xl"
          centered
          className="view-product-modal"
        >
          <Modal.Header closeButton>
            <h2>Product Details</h2>
          </Modal.Header>
          <Modal.Body>
            {selectedProduct && (
              <div className="view-product-content">
                <div className="view-product-header">
                  <div className="view-product-image-main">
                    {selectedProduct.variants &&
                    selectedProduct.variants.length > 0 &&
                    selectedProduct.variants[0].images &&
                    selectedProduct.variants[0].images.length > 0 ? (
                      <img
                        src={selectedProduct.variants[0].images[0].image_url}
                        alt={selectedProduct.name}
                      />
                    ) : (
                      <div className="image-placeholder-large">
                        <FaImage />
                      </div>
                    )}
                  </div>
                  <div className="view-product-summary">
                    <div className="product-code-badge">
                      {selectedProduct.code}
                    </div>
                    <h1 className="view-product-name">
                      {selectedProduct.name}
                    </h1>
                    <div className="view-product-meta">
                      <span className="material-badge">
                        {getMaterialLabel(selectedProduct.material)}
                      </span>
                      <span className="category-badge">
                        {getCategoryLabel(selectedProduct.category)}
                      </span>
                      <span
                        className={`status-badge ${
                          selectedProduct.is_available ? 'active' : 'inactive'
                        }`}
                      >
                        {selectedProduct.is_available ? (
                          <>
                            <FaCheckCircle /> Available
                          </>
                        ) : (
                          <>
                            <FaTimesCircle /> Unavailable
                          </>
                        )}
                      </span>
                    </div>
                    <div className="view-product-price">
                      <span className="price-main">
                        {getPriceRange(selectedProduct)}
                      </span>
                    </div>
                    <div className="view-product-quick-stats">
                      <div className="quick-stat">
                        <FaBoxes />
                        <span>
                          <strong>{getTotalStock(selectedProduct)}</strong> in
                          stock
                        </span>
                      </div>
                      <div className="quick-stat">
                        <FaShoppingBag />
                        <span>
                          <strong>{getTotalSold(selectedProduct)}</strong> sold
                        </span>
                      </div>
                      <div className="quick-stat">
                        <FaPalette />
                        <span>
                          <strong>
                            {selectedProduct.variants?.length || 0}
                          </strong>{' '}
                          colors
                        </span>
                      </div>
                      <div className="quick-stat">
                        <FaCalendarAlt />
                        <span>
                          Added {formatDate(selectedProduct.created_at)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="view-product-details-grid">
                  <div className="view-details-left">
                    <div className="view-section">
                      <h4>
                        <FaInfoCircle /> Description
                      </h4>
                      <p>
                        {selectedProduct.description ||
                          'No description provided'}
                      </p>
                    </div>

                    {selectedProduct.how_it_works && (
                      <div className="view-section">
                        <h4>How It Works</h4>
                        <p>{selectedProduct.how_it_works}</p>
                      </div>
                    )}

                    {selectedProduct.key_features && (
                      <div className="view-section">
                        <h4>Key Features</h4>
                        <p>{selectedProduct.key_features}</p>
                      </div>
                    )}

                    <div className="view-section">
                      <h4>
                        <FaRulerCombined /> Size & Weight
                      </h4>
                      <div className="view-dimensions">
                        <div className="dimension-item">
                          <span className="dimension-label">Size</span>
                          <span className="dimension-value">
                            {selectedProduct.dimensions}
                          </span>
                        </div>
                        {selectedProduct.weight && (
                          <div className="dimension-item">
                            <span className="dimension-label">Weight</span>
                            <span className="dimension-value">
                              {selectedProduct.weight}{' '}
                              {selectedProduct.weight_unit}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {selectedProduct.location && (
                      <div className="view-section">
                        <h4>
                          <FaStore /> Location
                        </h4>
                        <p>{selectedProduct.location}</p>
                      </div>
                    )}
                  </div>

                  <div className="view-details-right">
                    <div className="view-section">
                      <h4>
                        <FaPalette /> Colors / Options
                      </h4>
                      {selectedProduct.variants &&
                      selectedProduct.variants.length > 0 ? (
                        <div className="view-variants-list">
                          {selectedProduct.variants.map(
                            (variant, index) => (
                              <div
                                key={variant.id || index}
                                className="view-variant-item"
                              >
                                <div className="view-variant-header">
                                  <div className="view-variant-color">
                                    <span
                                      className="color-dot-large"
                                      style={{
                                        backgroundColor:
                                          variant.color_code || '#000000',
                                      }}
                                    />
                                    <span className="view-variant-name">
                                      {variant.color_name}
                                    </span>
                                    <span
                                      className={`variant-status ${
                                        variant.is_available
                                          ? 'available'
                                          : 'unavailable'
                                      }`}
                                    >
                                      {variant.is_available
                                        ? 'Available'
                                        : 'Unavailable'}
                                    </span>
                                  </div>
                                  <div className="view-variant-price">
                                    <span className="variant-selling-price">
                                      {variant.is_on_sale
                                        ? formatCurrency(variant.selling_price)
                                        : formatCurrency(
                                            variant.original_price,
                                          )}
                                    </span>
                                    {variant.is_on_sale &&
                                      variant.original_price &&
                                      variant.selling_price && (
                                        <span className="variant-original-price">
                                          {formatCurrency(
                                            variant.original_price,
                                          )}
                                        </span>
                                      )}
                                    {variant.is_on_sale && (
                                      <span className="variant-sale-badge">
                                        ON SALE
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="view-variant-details">
                                  <div className="variant-stock-info">
                                    <FaBoxes /> Stock:{' '}
                                    <strong>{variant.stock || 0}</strong>
                                    {variant.sold_count > 0 && (
                                      <span className="variant-sold">
                                        {' '}
                                        | Sold: {variant.sold_count}
                                      </span>
                                    )}
                                  </div>
                                  {variant.sale_start_date &&
                                    variant.sale_end_date && (
                                      <div className="variant-sale-dates">
                                        <FaTag /> Sale:{' '}
                                        {formatDate(variant.sale_start_date)} -{' '}
                                        {formatDate(variant.sale_end_date)}
                                      </div>
                                    )}

                                  <div className="variant-media-container">
                                    {variant.images &&
                                      variant.images.length > 0 && (
                                        <div className="variant-images-row">
                                          {variant.images.map(
                                            (img, imgIndex) => (
                                              <div
                                                key={imgIndex}
                                                className="variant-image-thumb-wrapper"
                                              >
                                                <img
                                                  src={img.image_url}
                                                  alt={`${variant.color_name} ${
                                                    img.image_type || ''
                                                  }`}
                                                  className="variant-thumb"
                                                  onClick={() => {
                                                    window.open(
                                                      img.image_url,
                                                      '_blank',
                                                    );
                                                  }}
                                                />
                                                {img.image_type && (
                                                  <span className="image-type-tag">
                                                    {img.image_type}
                                                  </span>
                                                )}
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      )}

                                    {variant.video &&
                                      variant.video.video_url && (
                                        <div className="variant-video-container">
                                          <div className="variant-video-wrapper">
                                            <video
                                              controls
                                              className="variant-video-player"
                                              poster={
                                                variant.images &&
                                                variant.images.length > 0
                                                  ? variant.images[0].image_url
                                                  : null
                                              }
                                            >
                                              <source
                                                src={variant.video.video_url}
                                                type="video/mp4"
                                              />
                                              Your browser does not support
                                              the video tag.
                                            </video>
                                            <div className="video-badge">
                                              <FaVideo /> Video
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            ),
                          )}
                        </div>
                      ) : (
                        <div className="no-variants-view">
                          <FaPalette />
                          <p>No color options available</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => setShowViewModal(false)}
            >
              Close
            </button>
            {selectedProduct && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowViewModal(false);
                  handleEditClick(selectedProduct);
                }}
              >
                <FaEdit /> Edit Product
              </button>
            )}
          </Modal.Footer>
        </Modal>

        {/* ============================================= */}
        {/* EDIT PRODUCT MODAL */}
        {/* ============================================= */}
        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          size="xl"
          centered
          className="edit-product-modal"
        >
          <Modal.Header closeButton>
            <h2>Edit Product</h2>
          </Modal.Header>
          <Modal.Body>
            <div className="edit-product-content">
              {/* Product Info Section */}
              <div className="edit-product-section">
                <h3>Product Details</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Product Name</label>
                    <input
                      type="text"
                      value={editProduct.name}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Code</label>
                    <input
                      type="text"
                      value={selectedProduct?.code || ''}
                      disabled
                      className="disabled-input"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Material</label>
                    <select
                      value={editProduct.material}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          material: e.target.value,
                        })
                      }
                    >
                      {MATERIAL_CHOICES.map((choice) => (
                        <option key={choice.value} value={choice.value}>
                          {choice.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Category</label>
                    <select
                      value={editProduct.category}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          category: e.target.value,
                        })
                      }
                    >
                      {CATEGORY_CHOICES.map((choice) => (
                        <option key={choice.value} value={choice.value}>
                          {choice.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={editProduct.description}
                    onChange={(e) =>
                      setEditProduct({
                        ...editProduct,
                        description: e.target.value,
                      })
                    }
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label>How It Works</label>
                  <textarea
                    value={editProduct.how_it_works}
                    onChange={(e) =>
                      setEditProduct({
                        ...editProduct,
                        how_it_works: e.target.value,
                      })
                    }
                    rows="2"
                  />
                </div>
                <div className="form-group">
                  <label>Key Features</label>
                  <textarea
                    value={editProduct.key_features}
                    onChange={(e) =>
                      setEditProduct({
                        ...editProduct,
                        key_features: e.target.value,
                      })
                    }
                    rows="2"
                  />
                </div>
                <div className="form-group">
                  <label>Location</label>
                  <input
                    type="text"
                    value={editProduct.location}
                    onChange={(e) =>
                      setEditProduct({
                        ...editProduct,
                        location: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Dimensions</label>
                  <div className="dimension-input-group">
                    <input
                      type="number"
                      value={editProduct.length}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          length: e.target.value,
                        })
                      }
                      placeholder="L"
                      step="0.01"
                    />
                    <span>×</span>
                    <input
                      type="number"
                      value={editProduct.width}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          width: e.target.value,
                        })
                      }
                      placeholder="W"
                      step="0.01"
                    />
                    <span>×</span>
                    <input
                      type="number"
                      value={editProduct.height}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          height: e.target.value,
                        })
                      }
                      placeholder="H"
                      step="0.01"
                    />
                    <select
                      value={editProduct.dimension_unit}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          dimension_unit: e.target.value,
                        })
                      }
                    >
                      {DIMENSION_UNIT_CHOICES.map((choice) => (
                        <option key={choice.value} value={choice.value}>
                          {choice.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={editProduct.is_available}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          is_available: e.target.checked,
                        })
                      }
                    />
                    Available for purchase
                  </label>
                </div>
              </div>

              {/* Variants Section */}
              <div className="edit-variants-section">
                <div className="edit-variants-header">
                  <h3>Colors / Options</h3>
                  <button
                    type="button"
                    className="add-variant-btn"
                    onClick={handleAddEditVariant}
                  >
                    <FaPlus /> Add Color
                  </button>
                </div>
                <p className="edit-variant-note">
                  Edit each color's price, stock, and sale information
                </p>

                {editVariants.length === 0 ? (
                  <div className="no-variants-edit">
                    <FaPalette />
                    <p>
                      No colors added yet. Click "Add Color" to get started.
                    </p>
                  </div>
                ) : (
                  <div className="edit-variants-list">
                    {editVariants.map((variant, index) => (
                      <div
                        key={variant.id || index}
                        className="edit-variant-item"
                      >
                        <div className="edit-variant-info">
                          <div className="edit-variant-color">
                            <span
                              className="color-dot"
                              style={{
                                backgroundColor:
                                  variant.color_code || '#000000',
                              }}
                            />
                            <span className="color-name">
                              {variant.color_name}
                            </span>
                            <span
                              className={`variant-status-badge ${
                                variant.is_available
                                  ? 'available'
                                  : 'unavailable'
                              }`}
                            >
                              {variant.is_available
                                ? 'Available'
                                : 'Unavailable'}
                            </span>
                            {variant.sale_start_date &&
                              variant.sale_end_date && (
                                <span className="sale-badge-small">
                                  On Sale
                                </span>
                              )}
                          </div>
                          <div className="edit-variant-pricing">
                            <span className="edit-price-selling">
                              {formatCurrency(variant.selling_price)}
                            </span>
                            {variant.original_price &&
                              variant.selling_price &&
                              variant.selling_price <
                                variant.original_price && (
                                <span className="edit-price-original">
                                  {formatCurrency(variant.original_price)}
                                </span>
                              )}
                            <span className="edit-variant-stock">
                              Stock: {variant.stock}
                            </span>
                          </div>
                        </div>
                        <div className="edit-variant-actions">
                          <button
                            type="button"
                            className="edit-variant-btn"
                            onClick={() => handleEditVariantClick(index)}
                          >
                            <FaEdit />
                          </button>
                          <button
                            type="button"
                            className="remove-variant-btn"
                            onClick={() => handleRemoveEditVariant(index)}
                            disabled={editVariants.length <= 1}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => setShowEditModal(false)}
              disabled={actionLoading.edit}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleUpdateProduct}
              disabled={actionLoading.edit}
            >
              {actionLoading.edit ? (
                <>
                  <FaSpinner className="spinner" /> Saving...
                </>
              ) : (
                'Save Changes'
              )}
            </button>
          </Modal.Footer>
        </Modal>

        {/* ============================================= */}
        {/* EDIT VARIANT MODAL */}
        {/* ============================================= */}
        <Modal
          show={showEditVariantModal}
          onHide={() => {
            setShowEditVariantModal(false);
            setEditingVariantIndex(null);
            setEditingVariantId(null);
          }}
          size="lg"
          centered
          className="variant-modal"
        >
          <Modal.Header closeButton>
            <h2>
              {editingVariantIndex !== null && editingVariantId
                ? 'Edit'
                : 'Add'}{' '}
              Color Option
            </h2>
          </Modal.Header>
          <Modal.Body>
            <div className="variant-form-grid">
              <div className="variant-form-left">
                <div className="form-group">
                  <label>
                    Color Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    value={editVariant.color_name}
                    onChange={(e) =>
                      setEditVariant({
                        ...editVariant,
                        color_name: e.target.value,
                      })
                    }
                    placeholder="e.g., Brown, Black, White"
                  />
                </div>
                <div className="form-group">
                  <label>Color Code (HEX)</label>
                  <div className="color-input-group">
                    <input
                      type="color"
                      value={editVariant.color_code}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          color_code: e.target.value,
                        })
                      }
                    />
                    <input
                      type="text"
                      value={editVariant.color_code}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          color_code: e.target.value,
                        })
                      }
                      placeholder="#RRGGBB"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>
                      Original Price (KSh){' '}
                      <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      value={editVariant.original_price}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          original_price: e.target.value,
                        })
                      }
                      placeholder="e.g., 8000"
                      min="0"
                      step="0.01"
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Selling Price (KSh){' '}
                      <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      value={editVariant.selling_price}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          selling_price: e.target.value,
                        })
                      }
                      placeholder="e.g., 8000"
                      min="0"
                      step="0.01"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>
                      Stock <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      value={editVariant.stock}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          stock: e.target.value,
                        })
                      }
                      min="0"
                    />
                  </div>
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        checked={editVariant.is_available}
                        onChange={(e) =>
                          setEditVariant({
                            ...editVariant,
                            is_available: e.target.checked,
                          })
                        }
                      />
                      Available
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Sale Start Date (Optional)</label>
                    <input
                      type="datetime-local"
                      value={editVariant.sale_start_date}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          sale_start_date: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Sale End Date (Optional)</label>
                    <input
                      type="datetime-local"
                      value={editVariant.sale_end_date}
                      onChange={(e) =>
                        setEditVariant({
                          ...editVariant,
                          sale_end_date: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="variant-form-right">
                <div className="form-group">
                  <label>Images</label>
                  <div className="image-upload-grid">
                    {['front', 'back', 'left', 'right'].map((type) => (
                      <div key={type} className="image-upload-item">
                        <label className="image-type-label">
                          {IMAGE_LABELS[type]}
                        </label>
                        <div className="image-upload-box">
                          <label className="upload-box-label">
                            <FaUpload />
                            <span>Upload</span>
                            <small>
                              Current: {editVariant[`${type}Image`] ? '1' : '0'}
                            </small>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  setEditVariant({
                                    ...editVariant,
                                    [`${type}Image`]: file,
                                    [`${type}Preview`]:
                                      URL.createObjectURL(file),
                                  });
                                }
                              }}
                              style={{ display: 'none' }}
                            />
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label>Video (Optional)</label>
                  <div className="video-upload-box">
                    <label className="upload-box-label video">
                      <FaUpload />
                      <span>Upload Video</span>
                      <small>MP4, WebM up to 50MB</small>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setEditVariant({
                              ...editVariant,
                              videoFile: file,
                              videoPreview: URL.createObjectURL(file),
                            });
                          }
                        }}
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>
                  {editVariant.videoPreview && (
                    <div className="video-preview">
                      <video src={editVariant.videoPreview} controls />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowEditVariantModal(false);
                setEditingVariantIndex(null);
                setEditingVariantId(null);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={
                editingVariantIndex !== null && editingVariantId
                  ? handleUpdateVariant
                  : handleSaveEditVariant
              }
              disabled={
                !editVariant.color_name || editVariant.color_name.trim() === ''
              }
            >
              <FaPlus />{' '}
              {editingVariantIndex !== null && editingVariantId
                ? 'Update'
                : 'Add'}{' '}
              Color
            </button>
          </Modal.Footer>
        </Modal>

        {/* ============================================= */}
        {/* ADD PRODUCT MODAL */}
        {/* ============================================= */}
        <Modal
          show={showAddModal}
          onHide={() => {
            setShowAddModal(false);
            resetProductForm();
          }}
          size="xl"
          centered
          className="add-product-modal"
        >
          <Modal.Header closeButton>
            <h2>Add New Product</h2>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-flex-container">
              <div className="form-column">
                <div className="form-section">
                  <h3>Product Details</h3>
                  <div className="form-group">
                    <label>
                      Product Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={newProduct.name}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          name: e.target.value,
                        })
                      }
                      placeholder="e.g., Modern Wooden Chair"
                    />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        Material <span className="required">*</span>
                      </label>
                      <select
                        value={newProduct.material}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            material: e.target.value,
                          })
                        }
                      >
                        {MATERIAL_CHOICES.map((choice) => (
                          <option key={choice.value} value={choice.value}>
                            {choice.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>
                        Category <span className="required">*</span>
                      </label>
                      <select
                        value={newProduct.category}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            category: e.target.value,
                          })
                        }
                      >
                        {CATEGORY_CHOICES.map((choice) => (
                          <option key={choice.value} value={choice.value}>
                            {choice.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      value={newProduct.description}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          description: e.target.value,
                        })
                      }
                      placeholder="Describe your product..."
                      rows="3"
                    />
                  </div>
                  <div className="form-group">
                    <label>How It Works</label>
                    <textarea
                      value={newProduct.how_it_works}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          how_it_works: e.target.value,
                        })
                      }
                      placeholder="Explain how to use it..."
                      rows="2"
                    />
                  </div>
                  <div className="form-group">
                    <label>Key Features</label>
                    <textarea
                      value={newProduct.key_features}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          key_features: e.target.value,
                        })
                      }
                      placeholder="List important features..."
                      rows="2"
                    />
                  </div>
                </div>

                <div className="form-section">
                  <h3>Size & Weight</h3>
                  <div className="form-row three-col">
                    <div className="form-group">
                      <label>Length</label>
                      <input
                        type="number"
                        value={newProduct.length}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            length: e.target.value,
                          })
                        }
                        placeholder="0.00"
                        step="0.01"
                      />
                    </div>
                    <div className="form-group">
                      <label>Width</label>
                      <input
                        type="number"
                        value={newProduct.width}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            width: e.target.value,
                          })
                        }
                        placeholder="0.00"
                        step="0.01"
                      />
                    </div>
                    <div className="form-group">
                      <label>Height</label>
                      <input
                        type="number"
                        value={newProduct.height}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            height: e.target.value,
                          })
                        }
                        placeholder="0.00"
                        step="0.01"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Unit</label>
                      <select
                        value={newProduct.dimension_unit}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            dimension_unit: e.target.value,
                          })
                        }
                      >
                        {DIMENSION_UNIT_CHOICES.map((choice) => (
                          <option key={choice.value} value={choice.value}>
                            {choice.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Weight</label>
                      <input
                        type="number"
                        value={newProduct.weight}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            weight: e.target.value,
                          })
                        }
                        placeholder="0.00"
                        step="0.01"
                      />
                    </div>
                    <div className="form-group">
                      <label>Weight Unit</label>
                      <select
                        value={newProduct.weight_unit}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            weight_unit: e.target.value,
                          })
                        }
                      >
                        {WEIGHT_UNIT_CHOICES.map((choice) => (
                          <option key={choice.value} value={choice.value}>
                            {choice.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h3>Location & Availability</h3>
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      value={newProduct.location}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          location: e.target.value,
                        })
                      }
                      placeholder="e.g., Nairobi, Kenya"
                    />
                  </div>
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        checked={newProduct.is_available}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            is_available: e.target.checked,
                          })
                        }
                      />
                      Available for purchase
                    </label>
                  </div>
                </div>
              </div>

              <div className="colors-column">
                <div className="form-section">
                  <div className="colors-header">
                    <h3>
                      Colors / Options <span className="required">*</span>
                    </h3>
                    <button
                      type="button"
                      className="add-color-btn"
                      onClick={() => {
                        setEditingColorIndex(null);
                        resetColorForm();
                        setShowAddColorModal(true);
                      }}
                    >
                      <FaPlus /> Add Color
                    </button>
                  </div>
                  <p className="color-required-note">
                    Add at least one color option for your product
                  </p>

                  {newProduct.colorOptions.length === 0 ? (
                    <div className="no-colors">
                      <FaPalette />
                      <p>
                        No colors added yet. Click "Add Color" to get started.
                      </p>
                    </div>
                  ) : (
                    <div className="colors-list">
                      {newProduct.colorOptions.map((color, index) => {
                        const imageCount = [
                          'front',
                          'back',
                          'left',
                          'right',
                        ].filter((type) => color[`${type}Image`]).length;
                        const hasVideo = !!color.videoFile;
                        const isOnSale =
                          color.sale_start_date &&
                          color.sale_end_date &&
                          new Date() >= new Date(color.sale_start_date) &&
                          new Date() <= new Date(color.sale_end_date);

                        return (
                          <div key={index} className="color-item">
                            <div className="color-info">
                              <div className="color-display">
                                <span
                                  className="color-dot"
                                  style={{
                                    backgroundColor:
                                      color.color_code || '#000000',
                                  }}
                                />
                                <span className="color-name">
                                  {color.color}
                                </span>
                                {isOnSale && (
                                  <span className="sale-tag">SALE</span>
                                )}
                              </div>
                              <div className="color-media">
                                {imageCount > 0 && (
                                  <span className="media-badge">
                                    <FaImage /> {imageCount}
                                  </span>
                                )}
                                {hasVideo && (
                                  <span className="media-badge video">
                                    <FaVideo /> 1
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="color-pricing">
                              <span className="price-selling">
                                {formatCurrency(color.selling_price)}
                              </span>
                              {color.original_price &&
                                color.selling_price &&
                                color.selling_price <
                                  color.original_price && (
                                  <span className="price-original">
                                    {formatCurrency(color.original_price)}
                                  </span>
                                )}
                              <span className="color-stock">
                                Stock: {color.stock || 0}
                              </span>
                            </div>
                            <div className="color-actions">
                              <button
                                type="button"
                                className="edit-color-btn"
                                onClick={() => handleEditColorOption(index)}
                              >
                                <FaEdit />
                              </button>
                              <button
                                type="button"
                                className="remove-color-btn"
                                onClick={() => handleRemoveColorOption(index)}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowAddModal(false);
                resetProductForm();
              }}
              disabled={actionLoading.add}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleAddProduct}
              disabled={
                actionLoading.add || newProduct.colorOptions.length === 0
              }
            >
              {actionLoading.add ? (
                <>
                  <FaSpinner className="spinner" /> Adding...
                </>
              ) : (
                <>
                  <FaPlus /> Add Product
                </>
              )}
            </button>
          </Modal.Footer>
        </Modal>

        {/* ============================================= */}
        {/* ADD COLOR MODAL */}
        {/* ============================================= */}
        <Modal
          show={showAddColorModal}
          onHide={() => {
            setShowAddColorModal(false);
            setEditingColorIndex(null);
            resetColorForm();
          }}
          size="lg"
          centered
          className="color-modal"
        >
          <Modal.Header closeButton>
            <h2>
              {editingColorIndex !== null ? 'Edit' : 'Add'} Color Option
            </h2>
          </Modal.Header>
          <Modal.Body>
            <div className="color-form-grid">
              <div className="color-form-left">
                <div className="form-group">
                  <label>
                    Color Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    value={newColorOption.color}
                    onChange={(e) =>
                      setNewColorOption({
                        ...newColorOption,
                        color: e.target.value,
                      })
                    }
                    placeholder="e.g., Brown, Black, White"
                  />
                </div>
                <div className="form-group">
                  <label>Color Code (HEX)</label>
                  <div className="color-input-group">
                    <input
                      type="color"
                      value={newColorOption.color_code}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          color_code: e.target.value,
                        })
                      }
                    />
                    <input
                      type="text"
                      value={newColorOption.color_code}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          color_code: e.target.value,
                        })
                      }
                      placeholder="#RRGGBB"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>
                      Original Price (KSh){' '}
                      <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      value={newColorOption.original_price}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          original_price: e.target.value,
                        })
                      }
                      placeholder="e.g., 8000"
                      min="0"
                      step="0.01"
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Selling Price (KSh){' '}
                      <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      value={newColorOption.selling_price}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          selling_price: e.target.value,
                        })
                      }
                      placeholder="e.g., 8000"
                      min="0"
                      step="0.01"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>
                      Stock <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      value={newColorOption.stock}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          stock: e.target.value,
                        })
                      }
                      min="0"
                    />
                  </div>
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        checked={newColorOption.is_available}
                        onChange={(e) =>
                          setNewColorOption({
                            ...newColorOption,
                            is_available: e.target.checked,
                          })
                        }
                      />
                      Available
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Sale Start Date (Optional)</label>
                    <input
                      type="datetime-local"
                      value={newColorOption.sale_start_date}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          sale_start_date: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Sale End Date (Optional)</label>
                    <input
                      type="datetime-local"
                      value={newColorOption.sale_end_date}
                      onChange={(e) =>
                        setNewColorOption({
                          ...newColorOption,
                          sale_end_date: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="color-form-right">
                <div className="form-group">
                  <label>Photos of this color</label>
                  <div className="image-upload-grid">
                    {['front', 'back', 'left', 'right'].map((type) => (
                      <div key={type} className="image-upload-item">
                        <label className="image-type-label">
                          {IMAGE_LABELS[type]}
                        </label>
                        <div className="image-upload-box">
                          {newColorOption[`${type}Preview`] ? (
                            <div className="image-preview">
                              <img
                                src={newColorOption[`${type}Preview`]}
                                alt={type}
                              />
                              <button
                                type="button"
                                className="remove-image"
                                onClick={() => removeColorImage(type)}
                              >
                                <FaTimes />
                              </button>
                            </div>
                          ) : (
                            <label className="upload-box-label">
                              <FaUpload />
                              <span>Upload</span>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleColorImageUpload(type, e)
                                }
                                style={{ display: 'none' }}
                              />
                            </label>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label>Video of this color (Optional)</label>
                  <div className="video-upload-box">
                    {newColorOption.videoPreview ? (
                      <div className="video-preview">
                        <video src={newColorOption.videoPreview} controls />
                        <button
                          type="button"
                          className="remove-video"
                          onClick={removeColorVideo}
                        >
                          <FaTimes />
                        </button>
                      </div>
                    ) : (
                      <label className="upload-box-label video">
                        <FaUpload />
                        <span>Upload Video</span>
                        <small>MP4, WebM up to 50MB</small>
                        <input
                          type="file"
                          accept="video/*"
                          onChange={handleColorVideoUpload}
                          style={{ display: 'none' }}
                        />
                      </label>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowAddColorModal(false);
                setEditingColorIndex(null);
                resetColorForm();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleAddColorOption}
              disabled={
                !newColorOption.color || newColorOption.color.trim() === ''
              }
            >
              <FaPlus /> {editingColorIndex !== null ? 'Update' : 'Add'} Color
            </button>
          </Modal.Footer>
        </Modal>

        {/* ============================================= */}
        {/* DELETE CONFIRMATION MODAL */}
        {/* ============================================= */}
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
          className="delete-modal"
        >
          <Modal.Header closeButton>
            <h2>Delete Product</h2>
          </Modal.Header>
          <Modal.Body>
            {productToDelete && (
              <p>
                Are you sure you want to delete{' '}
                <strong>"{productToDelete.name}"</strong>? This action cannot be
                undone.
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => setShowDeleteModal(false)}
              disabled={actionLoading.delete}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleDeleteProduct}
              disabled={actionLoading.delete}
            >
              {actionLoading.delete ? (
                <>
                  <FaSpinner className="spinner" /> Deleting...
                </>
              ) : (
                'Delete Product'
              )}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ArtisanReadyProducts, 'artisan');